var nt = Object.defineProperty, st = Object.defineProperties;
var it = Object.getOwnPropertyDescriptors;
var ce = Object.getOwnPropertySymbols;
var ot = Object.prototype.hasOwnProperty, at = Object.prototype.propertyIsEnumerable;
var Y = (t, e, r) => e in t ? nt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, S = (t, e) => {
  for (var r in e || (e = {}))
    ot.call(e, r) && Y(t, r, e[r]);
  if (ce)
    for (var r of ce(e))
      at.call(e, r) && Y(t, r, e[r]);
  return t;
}, $ = (t, e) => st(t, it(e));
var K = (t, e, r) => Y(t, typeof e != "symbol" ? e + "" : e, r);
var u = (t, e, r) => new Promise((n, s) => {
  var i = (c) => {
    try {
      a(r.next(c));
    } catch (h) {
      s(h);
    }
  }, o = (c) => {
    try {
      a(r.throw(c));
    } catch (h) {
      s(h);
    }
  }, a = (c) => c.done ? n(c.value) : Promise.resolve(c.value).then(i, o);
  a((r = r.apply(t, e)).next());
});
class d extends Error {
  constructor(e, r) {
    super(e), this.cause = r;
  }
}
class j extends Error {
  constructor(e, r) {
    super(`${e} - ${r}`);
  }
}
const R = {
  DEFAULT_PKCE_LENGTH: 48,
  MAX_PKCE_LENGTH: 128,
  MIN_PKCE_LENGTH: 43
};
var E = /* @__PURE__ */ ((t) => (t[t.DEBUG = 0] = "DEBUG", t[t.INFO = 1] = "INFO", t[t.WARN = 2] = "WARN", t[t.ERROR = 3] = "ERROR", t))(E || {}), f = /* @__PURE__ */ ((t) => (t.AUTH_STATE_MANAGER = "MapSSO AuthStateManager", t.FETCH = "MapSSO Fetch", t.MAP_SSO = "MapSSO", t.OIDC_CONFIG_MANAGER = "MapSSO OidcConfigManager", t.PKCE_MANAGER = "MapSSO PkceManager", t.ROUTER = "MapSSO Router", t.STATE_VERIFIER = "MapSSO StateVerifier", t.TOKEN_MANAGER = "MapSSO TokenManager", t.STORAGE_UTILS = "MapSSO StorageUtils", t.LEADER_ELECTION = "MapSSO LeaderElection Service", t.AUTO_RENEWAL = "MapSSO AutoRenewal Service", t.SERVICE_MANAGER = "MapSSO ServiceManager", t.SYNC_STORAGE = "MapSSO SyncStorage Service", t.SINGLE_SIGN_OUT = "MapSSO Single Sign Out Service", t.AUTHN = "MapSSO Authn", t.TRANSACTION_MANAGER = "MapSSO TransactionManager", t.AUTH_STATE_SERVICE = "MapSSO Auth State Service", t))(f || {});
const ct = 60 * 1e3 * 10, ut = 1e3 * 60, Ee = {
  LEADER_ELECTION: "map-sso:leader-election",
  SYNC_STORAGE: "map-sso:sync-storage"
};
function ye(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, r) {
    var n = t.get(e);
    n ? n.push(r) : t.set(e, [r]);
  }, off: function(e, r) {
    var n = t.get(e);
    n && (r ? n.splice(n.indexOf(r) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, r) {
    var n = t.get(e);
    n && n.slice().map(function(s) {
      s(r);
    }), (n = t.get("*")) && n.slice().map(function(s) {
      s(e, r);
    });
  } };
}
const B = () => {
}, ht = "rgb(13, 41, 110)", dt = "#efefef", N = class N {
  constructor(e = f.MAP_SSO, r = E.ERROR, { bgColor: n = ht, textColor: s = dt } = {}) {
    this.level = r;
    const i = `%c${e}`, o = `background-color: ${n}; color: ${s}; font-weight: bold ; padding: 6px;`;
    this.debug = this.level <= E.DEBUG ? console.debug.bind(window.console, i, o) : B, this.info = this.level <= E.INFO ? console.info.bind(window.console, i, o) : B, this.warn = this.level <= E.WARN ? console.warn.bind(window.console, i, o) : B, this.error = this.level <= E.ERROR ? console.error.bind(window.console, i, o) : B;
  }
  static initLogger(e, r, n) {
    return this.GlobalLogLevel = r, this.logger = new N(e, r, n), this.logger;
  }
  static getLogger() {
    if (!this.logger)
      throw new d("Logger not initialized");
    return this.logger;
  }
  static createLogger(e, r = this.GlobalLogLevel, n) {
    return new N(e, r, n);
  }
};
N.GlobalLogLevel = E.ERROR;
let g = N;
const y = {
  CACHE: "ma-sso-cache",
  TRANSACTION: "ma-sso-transaction",
  TOKENS: "ma-sso-tokens",
  TEST: "ma-sso-storage-manager-test"
  // Used for validating that a storage-manager interface is accessible at runtime
}, ue = {
  OIDC_CONFIGURATION: "oidc-configuration"
}, w = {
  PKCE: "pkce-verifier",
  STATE: "oauth-state",
  NONCE: "openid-nonce",
  ORIGINAL_URI: "original-uri"
}, m = {
  ACCESS_TOKEN: "accessToken",
  ID_TOKEN: "idToken",
  REFRESH_TOKEN: "refreshToken",
  PENDING_REMOVAL: "pendingRemoval",
  ISSUER: "issuer",
  SCOPES: "scopes",
  TOKEN_USE: "tokenUse"
}, lt = 365 * 24 * 60 * 60 * 1e3;
function Me(t) {
  return t.toString(16).padStart(2, "0");
}
function Ce(t, e) {
  const r = e.getRandomValues(new Uint8Array(Math.ceil(t / 2)));
  return Array.from(r, Me).join("");
}
function be(t, e) {
  const n = new TextEncoder().encode(t);
  return e.subtle.digest("SHA-256", n);
}
function gt(t) {
  const e = new Uint8Array(t);
  return Array.from(e, Me).join("");
}
function ft(t) {
  const e = new Uint8Array(t);
  return window.btoa(String.fromCharCode(...e)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function pt(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error(`Invalid base64URL string: ${e}`);
  }
  const r = window.atob(e);
  try {
    return decodeURIComponent(
      r.replace(/(.)/g, (n, s) => {
        let i = s.charCodeAt(0).toString(16).toUpperCase();
        return i.length < 2 && (i = "0" + i), "%" + i;
      })
    );
  } catch (n) {
    return r;
  }
}
function he(t) {
  const r = t.split(".")[1];
  if (typeof r != "string" || r.length === 0)
    throw new Error("Invalid JWT token");
  let n;
  try {
    n = pt(r);
  } catch (s) {
    throw new d(
      `Invalid JWT token provided. Body is invalid base64url encoded string: 
${s.message}`
    );
  }
  try {
    return JSON.parse(n);
  } catch (s) {
    throw new d(`Invalid JWT token provided. Body is not a valid JSON string: 
${s.message}`);
  }
}
function O(t, e) {
  var r, n;
  if (!t)
    throw new d("Token missing");
  switch (e.type) {
    case "access": {
      const s = he(t);
      return {
        issuer: (r = s.iss) != null ? r : e.issuer,
        token: t,
        claims: s,
        expiresAt: de(Number(s.exp)),
        tokenUse: e.tokenUse,
        scopes: e.scopes,
        tokenType: "access"
      };
    }
    case "id": {
      const s = he(t);
      return {
        issuer: (n = s.iss) != null ? n : e.issuer,
        token: t,
        claims: s,
        expiresAt: de(Number(s.exp)),
        scopes: e.scopes,
        tokenType: "id"
      };
    }
    case "refresh":
      return {
        issuer: e.issuer,
        token: t,
        tokenType: "refresh"
      };
  }
}
function de(t) {
  return t * 1e3;
}
function Oe(t, e) {
  const r = t.scope.split(" ");
  return {
    accessToken: O(t.access_token, {
      type: "access",
      issuer: e,
      scopes: r,
      tokenUse: t.token_type
    }),
    idToken: O(t.id_token, {
      type: "id",
      issuer: e,
      scopes: r
    }),
    refreshToken: O(t.refresh_token, {
      type: "refresh",
      issuer: e
    })
  };
}
const le = () => ({
  login: { inProgress: !1, promise: null, id: null },
  logout: { inProgress: !1, promise: null, id: null },
  renew: { inProgress: !1, promise: null, id: null },
  "handle-redirect": { inProgress: !1, promise: null, id: null }
});
class U {
  constructor() {
    this.transactions = le(), this.logger = g.createLogger(f.TRANSACTION_MANAGER);
  }
  /**
   * Used to create a new transaction. If a transaction of the same type is already in progress,
   * this will return a rejected promise.
   *
   * Receives a callback function that returns a promise. The promise is registered as the current transaction.
   * Once it has resolved or rejected, the transaction is cleared.
   *
   * If not locked, `create` will return the promise returned by the callback function. This can be awaited to get the result of the transaction.
   *
   * @param key
   * @param p
   */
  create(e, r) {
    if (this.locked(e))
      return this.logger.warn(`A Transaction of type ${e} is already in progress`), Promise.reject(new d(`A Transaction of type ${e} is already in progress`));
    const n = crypto.randomUUID(), s = r();
    return this.transactions[e] = { inProgress: !0, promise: s, id: n }, s.then(this.finishTransaction(e, n), this.finishTransaction(e, n)), s;
  }
  /**
   * Check if a transaction is currently locked (in-progress)
   * @param key
   */
  locked(e) {
    return this.transactions[e].inProgress;
  }
  /**
   * Get the promise currently associated with a transaction
   * Useful for de-duping operations while still returning the result of the original operation
   * @param key
   */
  get(e) {
    return this.transactions[e].promise;
  }
  /**
   * Clear all transactions.
   * Note that this does not cancel any in-progress promises,
   * it only removes their references from the transaction manager.
   */
  clear() {
    this.transactions = le();
  }
  /**
   * Reset a transaction key after the original promise resolves/rejects
   * @param key
   * @param id
   * @private
   */
  finishTransaction(e, r) {
    return () => {
      r === this.transactions[e].id && (this.transactions[e] = { inProgress: !1, promise: null, id: null });
    };
  }
  static initTransactionManager() {
    return this.transactionManager = new U(), this.transactionManager;
  }
  static getSingleton() {
    return this.transactionManager ? this.transactionManager : this.initTransactionManager();
  }
}
class mt {
  constructor({ config: e, router: r, tokenStorage: n }) {
    this.emitter = ye(), this.logger = g.createLogger(f.TOKEN_MANAGER), this.renewTimeout = null, this.expiringWarningInMs = ct, this.expiredTimeout = null, this.started = !1, this.ssoConfig = e, this.tokenStorage = n, this.v2Router = r, this.transactionManager = U.getSingleton();
  }
  get accessToken() {
    var r;
    const e = this.getTokens();
    return e && (r = e.accessToken) != null ? r : null;
  }
  get idToken() {
    var r;
    const e = this.getTokens();
    return e && (r = e.idToken) != null ? r : null;
  }
  get refreshToken() {
    var r;
    const e = this.getTokens();
    return (r = e == null ? void 0 : e.refreshToken) != null ? r : null;
  }
  /**
   * See {@link ITokenManager#on}
   */
  on(e, r) {
    return this.emitter.on(e, r), () => this.emitter.off(e, r);
  }
  /**
   * See {@link ITokenManager#off}
   */
  off(e, r) {
    this.emitter.off(e, r);
  }
  /**
   * See {@link ITokenManager#setTokens}
   */
  setTokens(e) {
    var r, n, s, i, o, a;
    this.tokenStorage.setItem(m.ACCESS_TOKEN, (r = e.accessToken) == null ? void 0 : r.token), this.tokenStorage.setItem(m.ID_TOKEN, (n = e.idToken) == null ? void 0 : n.token), this.tokenStorage.setItem(m.REFRESH_TOKEN, (s = e.refreshToken) == null ? void 0 : s.token), this.tokenStorage.setItem(m.PENDING_REMOVAL, e.pendingRemoval), this.tokenStorage.setItem(m.ISSUER, (i = e.accessToken) == null ? void 0 : i.issuer), this.tokenStorage.setItem(m.SCOPES, (o = e.accessToken) == null ? void 0 : o.scopes), this.tokenStorage.setItem(m.TOKEN_USE, (a = e.accessToken) == null ? void 0 : a.tokenUse), this.emitter.emit("added", e);
  }
  /**
   * See {@link ITokenManager#getTokens}
   */
  getTokens() {
    var e, r;
    try {
      const n = (e = this.tokenStorage.getItem(m.ISSUER)) != null ? e : this.ssoConfig.issuer, s = (r = this.tokenStorage.getItem(m.SCOPES)) != null ? r : [], i = this.tokenStorage.getItem(m.TOKEN_USE), o = O(this.tokenStorage.getItem(m.ACCESS_TOKEN), {
        type: "access",
        issuer: n,
        scopes: s,
        tokenUse: i
      }), a = O(this.tokenStorage.getItem(m.ID_TOKEN), {
        type: "id",
        issuer: n,
        scopes: s
      }), c = O(this.tokenStorage.getItem(m.REFRESH_TOKEN), {
        type: "refresh",
        issuer: n
      }), h = this.tokenStorage.getItem(m.PENDING_REMOVAL);
      return {
        accessToken: o,
        idToken: a,
        refreshToken: c,
        pendingRemoval: h
      };
    } catch (n) {
      return this.logger.debug("Could not retrieve tokens from storage:", n instanceof Error ? n.message : n), null;
    }
  }
  /**
   * See {@link ITokenManager#clear}
   */
  clear() {
    const e = this.getTokens();
    Object.values(m).forEach((r) => this.tokenStorage.removeItem(r)), this.emitter.emit("removed", e);
  }
  /**
   * See {@link ITokenManager#start}
   */
  start() {
    return u(this, null, function* () {
      var r;
      if (this.started) {
        this.logger.debug("Cannot start TokenManager: already started");
        return;
      }
      this.logger.debug("Starting TokenManager"), this.clearPendingRemovalTokens();
      let e = this.getTokens();
      if (e != null && e.accessToken) {
        const { renewalTimeoutMs: n } = this.getExpirationTimeoutsInMs(e.accessToken);
        (this.hasExpired(e.accessToken) || n <= 6e4) && (e = (r = yield this.renew(e)) != null ? r : e), this.createRenewalTimers(e);
      }
      this.on("added", (n) => this.createRenewalTimers(n)), this.on("removed", () => this.clearTimeouts()), this.started = !0;
    });
  }
  /**
   * See {@link ITokenManager#stop}
   */
  stop() {
    if (!this.started) {
      this.logger.debug("Cannot stop TokenManager: already stopped");
      return;
    }
    this.logger.debug("Stopping token manager"), this.clearTimeouts(), this.started = !1;
  }
  /**
   * See {@link ITokenManager#renew}
   * @param tokens
   */
  renew() {
    return u(this, arguments, function* (e = this.getTokens()) {
      if (!e)
        return this.logger.warn("No tokens found in storage. Cannot renew tokens"), this.emitter.emit("renew-error", new Error("No tokens found in the storage. Cannot renew tokens")), null;
      const r = this.transactionManager.get("renew");
      return r !== null ? (this.logger.debug("Duplicate renew request detected. Resolving with existing renewal request."), yield r) : yield this.transactionManager.create("renew", () => u(this, null, function* () {
        var n, s;
        try {
          const i = yield this.v2Router.token({
            grant_type: "refresh_token",
            refresh_token: (s = (n = e.refreshToken) == null ? void 0 : n.token) != null ? s : "",
            client_id: this.ssoConfig.clientId,
            redirect_uri: this.ssoConfig.redirectUri
          }).then((o) => Oe(o, this.ssoConfig.issuer));
          return this.setTokens(i), this.logger.debug("Tokens renewed"), this.emitter.emit("renewed", i), i;
        } catch (i) {
          return this.logger.error("Error renewing tokens", i), this.emitter.emit("renew-error", i), this.clear(), null;
        }
      }));
    });
  }
  /**
   * See {@link ITokenManager#hasExpired}
   */
  hasExpired(e = this.accessToken) {
    if (!e) return !0;
    const r = Date.now() + ut;
    return e.expiresAt <= r;
  }
  /**
   * Creates two timers for watching token lifetime.
   * - The first timer will emit the `expiring` event when the token is within the buffer period of expiring (10 minutes).
   *
   * - The second timer will emit the `expired` event when the token has expired.
   *
   * @param tokens
   * @private
   */
  createRenewalTimers(e) {
    if (!e.accessToken) {
      this.logger.warn("No access token found. Cannot set renewal timers");
      return;
    }
    const { expiredTimeoutMs: r, renewalTimeoutMs: n } = this.getExpirationTimeoutsInMs(e.accessToken);
    if (this.hasExpired(e.accessToken)) {
      this.logger.warn("Access token is already expired. Cannot set renewal timers"), this.emitter.emit("expired", e);
      return;
    }
    this.clearTimeouts(), this.logger.debug(`Renewal timer set for ${new Date(Date.now() + n)}`), this.renewTimeout = setTimeout(() => this.emitter.emit("expiring", e), n), this.logger.debug(`Expired timer set for ${new Date(Date.now() + r)}`), this.expiredTimeout = setTimeout(() => this.emitter.emit("expired", e), r);
  }
  getExpirationTimeoutsInMs(e) {
    const r = new Date(e.expiresAt), n = Math.max(r.getTime() - Date.now(), 0), s = Math.max(n - this.expiringWarningInMs, 0);
    return { expiredTimeoutMs: n, renewalTimeoutMs: s };
  }
  /**
   * Clears any existing renewal timers.
   * @private
   */
  clearTimeouts() {
    var e, r;
    this.logger.debug("Clearing token renew and expiration timeouts"), clearTimeout((e = this.renewTimeout) != null ? e : 0), clearTimeout((r = this.expiredTimeout) != null ? r : 0), this.renewTimeout = null, this.expiredTimeout = null;
  }
  /**
   * See {@link ITokenManager#emitError}
   * @internal
   * @param error
   */
  emitError(e) {
    this.emitter.emit("renew-error", e);
  }
  /**
   * See {@link ITokenManager#emit}
   * @internal
   */
  emit(e, r) {
    this.emitter.emit(e, r);
  }
  /**
   * See {@link ITokenManager#hasStarted}
   */
  hasStarted() {
    return this.started;
  }
  /**
   * See {@link ITokenManager#setStorage}
   * @internal
   */
  setStorage(e) {
    this.tokenStorage.setStorage(e), this.emitter.emit("set-storage", this.tokenStorage.getStorage());
  }
  /**
   * See {@link ITokenManager#addPendingRemovalFlags}
   * @internal
   */
  addPendingRemovalFlags() {
    var r;
    const e = (r = this.getTokens()) != null ? r : {};
    e.pendingRemoval = !0, this.setTokens(e);
  }
  /**
   * See {@link ITokenManager#clearPendingRemovalTokens}
   * @internal
   */
  clearPendingRemovalTokens() {
    var r;
    ((r = this.getTokens()) != null ? r : {}).pendingRemoval && (this.logger.debug("Clearing pending removal tokens"), this.clear(), this.clearTimeouts());
  }
}
class St {
  constructor({ crypto: e, transactionStorage: r }) {
    this.logger = g.createLogger(f.STATE_VERIFIER), this.crypto = e, this.transactionStorage = r;
  }
  /**
   * Create a new id token nonce value and save it in transaction storage
   * Returns a hashed version of the nonce that will be passed to the authorization server.
   */
  createNonce() {
    return u(this, null, function* () {
      const e = Ce(32, this.crypto);
      return this.transactionStorage.setItem(w.NONCE, e), this.hashNonce(e);
    });
  }
  /**
   * Verify that the nonce hash returned by the authorization server matches the stored nonce hash.
   * @param nonce
   */
  verifyNonce(e) {
    return u(this, null, function* () {
      const r = yield this.hashNonce(this.transactionStorage.getItem(w.NONCE));
      if (e !== r)
        throw new j(
          "NonceMismatch",
          "The nonce returned by the authorization server does not match the stored nonce"
        );
      this.transactionStorage.removeItem(w.NONCE);
    });
  }
  /**
   * Generate a secure random state string and merge it with any user-provided state.
   * This combined state is serialized and stored for later verification.
   * @param userState
   */
  generate(e) {
    const r = this.crypto.randomUUID();
    this.logger.debug(`Created new state value: ${r}`);
    const n = {
      state: r,
      userState: e
    }, s = window.btoa(JSON.stringify(n));
    return this.logger.debug(`Storing encoded state object: ${s}`), this.transactionStorage.setItem(w.STATE, s), s;
  }
  /**
   * Decodes and returns the user state from the state parameter which is a base64 encoded string
   * @param state
   */
  decode(e) {
    return JSON.parse(window.atob(e)).userState;
  }
  /**
   * Verifies that the state parameter matches the stored state. Removes
   * the stored state after verification is complete.
   * @param state
   */
  verify(e) {
    const r = this.transactionStorage.getItem(w.STATE);
    if (typeof e != "string" || e !== r)
      throw this.logger.error("State mismatch. Cannot complete authorization flow"), new j(
        "StateMismatch",
        "The state returned by the authorization server does not match the stored state"
      );
    return this.transactionStorage.removeItem(w.STATE), e;
  }
  hashNonce(e) {
    return u(this, null, function* () {
      const r = yield be(e, this.crypto);
      return gt(r);
    });
  }
}
class wt {
  constructor({ crypto: e, transactionStorage: r }) {
    this.logger = g.createLogger(f.PKCE_MANAGER), this.CODE_METHOD = "S256", this.crypto = e, this.transactionStorage = r;
  }
  /**
   * Creates a new pkce code verifier/challenge pair
   */
  createCodePair() {
    return u(this, arguments, function* (e = R.DEFAULT_PKCE_LENGTH) {
      this.logger.debug("Creating new PKCE code pair");
      const r = this.createCodeVerifier(e), n = yield this.createCodeChallenge(r);
      return { codeVerifier: r, codeChallenge: n };
    });
  }
  /**
   * Retrieves a code verifier from storage. After retrieval,
   * the code verifier will be removed from storage to prevent stale codes from persisting.
   * @throws {AuthorizationError} if no code verifier is found in storage
   */
  retrieveCodeVerifier() {
    this.logger.debug("Retrieving PKCE code verifier from storage");
    const e = this.transactionStorage.getItem(w.PKCE);
    if (!e)
      throw this.logger.error("No PKCE code verifier found in storage. Cannot complete authorization flow"), new j("MissingCodeVerifier", "No code verifier found in storage");
    return e;
  }
  removeCodeVerifier() {
    this.logger.debug("Removing PKCE code verifier from storage"), this.transactionStorage.removeItem(w.PKCE);
  }
  /**
   * Creates a new pkce code verifier. The code verifier is persisted to storage.
   * This function is not pure. Each call will produce a new code verifier. Each new code verifier
   * will overwrite any previous values in storage.
   *
   * Optionally provide a PKCE length. This length will be validated and adjusted to conform to the
   * oauth spec.
   *
   * https://datatracker.ietf.org/doc/html/rfc7636#section-4.1
   * @param length
   */
  createCodeVerifier(e = R.DEFAULT_PKCE_LENGTH) {
    const r = e < R.MIN_PKCE_LENGTH ? R.MIN_PKCE_LENGTH : e, n = encodeURIComponent(Ce(r, this.crypto)).slice(
      0,
      R.MAX_PKCE_LENGTH
    );
    return this.logger.debug(`Created a new PKCE code verifier. Saving it to storage: ${n}`), this.transactionStorage.setItem(w.PKCE, n), n;
  }
  /**
   * Creates a new pkce code challenge from the provided code verifier
   * @param codeVerifier
   */
  createCodeChallenge(e) {
    return u(this, null, function* () {
      const r = yield be(e, this.crypto), n = ft(r);
      return this.logger.debug(`Created a new PKCE code challenge from code verifier: ${e}`), n;
    });
  }
}
class vt extends Error {
  constructor(e) {
    super(e);
  }
}
function b(t, e) {
  if (!t)
    throw new vt(e != null ? e : "Assertion failed");
}
function W(t, e = new d(`Exhaustive match failed: ${t}`)) {
  throw e;
}
class Ie extends Error {
  constructor(e, r, n) {
    super(`A network error occurred with status ${r}: 
	${e}
	URL: ${n}`), this.status = r, this.url = n;
  }
}
function Re(t) {
  return u(this, null, function* () {
    const e = g.createLogger(f.FETCH);
    if (t.ok)
      return e.debug("Received a 2xx response from the server"), t;
    throw e.debug("Received a non-2xx response from the server", t.status, t.statusText), new Ie(t.statusText, t.status, t.url);
  });
}
function Tt(t) {
  return Re(t).then((e) => e.json());
}
function _t(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Le = {};
function v(t, e) {
  typeof e == "boolean" && (e = { forever: e }), this._originalTimeouts = JSON.parse(JSON.stringify(t)), this._timeouts = t, this._options = e || {}, this._maxRetryTime = e && e.maxRetryTime || 1 / 0, this._fn = null, this._errors = [], this._attempts = 1, this._operationTimeout = null, this._operationTimeoutCb = null, this._timeout = null, this._operationStart = null, this._timer = null, this._options.forever && (this._cachedTimeouts = this._timeouts.slice(0));
}
var kt = v;
v.prototype.reset = function() {
  this._attempts = 1, this._timeouts = this._originalTimeouts.slice(0);
};
v.prototype.stop = function() {
  this._timeout && clearTimeout(this._timeout), this._timer && clearTimeout(this._timer), this._timeouts = [], this._cachedTimeouts = null;
};
v.prototype.retry = function(t) {
  if (this._timeout && clearTimeout(this._timeout), !t)
    return !1;
  var e = (/* @__PURE__ */ new Date()).getTime();
  if (t && e - this._operationStart >= this._maxRetryTime)
    return this._errors.push(t), this._errors.unshift(new Error("RetryOperation timeout occurred")), !1;
  this._errors.push(t);
  var r = this._timeouts.shift();
  if (r === void 0)
    if (this._cachedTimeouts)
      this._errors.splice(0, this._errors.length - 1), r = this._cachedTimeouts.slice(-1);
    else
      return !1;
  var n = this;
  return this._timer = setTimeout(function() {
    n._attempts++, n._operationTimeoutCb && (n._timeout = setTimeout(function() {
      n._operationTimeoutCb(n._attempts);
    }, n._operationTimeout), n._options.unref && n._timeout.unref()), n._fn(n._attempts);
  }, r), this._options.unref && this._timer.unref(), !0;
};
v.prototype.attempt = function(t, e) {
  this._fn = t, e && (e.timeout && (this._operationTimeout = e.timeout), e.cb && (this._operationTimeoutCb = e.cb));
  var r = this;
  this._operationTimeoutCb && (this._timeout = setTimeout(function() {
    r._operationTimeoutCb();
  }, r._operationTimeout)), this._operationStart = (/* @__PURE__ */ new Date()).getTime(), this._fn(this._attempts);
};
v.prototype.try = function(t) {
  console.log("Using RetryOperation.try() is deprecated"), this.attempt(t);
};
v.prototype.start = function(t) {
  console.log("Using RetryOperation.start() is deprecated"), this.attempt(t);
};
v.prototype.start = v.prototype.try;
v.prototype.errors = function() {
  return this._errors;
};
v.prototype.attempts = function() {
  return this._attempts;
};
v.prototype.mainError = function() {
  if (this._errors.length === 0)
    return null;
  for (var t = {}, e = null, r = 0, n = 0; n < this._errors.length; n++) {
    var s = this._errors[n], i = s.message, o = (t[i] || 0) + 1;
    t[i] = o, o >= r && (e = s, r = o);
  }
  return e;
};
(function(t) {
  var e = kt;
  t.operation = function(r) {
    var n = t.timeouts(r);
    return new e(n, {
      forever: r && (r.forever || r.retries === 1 / 0),
      unref: r && r.unref,
      maxRetryTime: r && r.maxRetryTime
    });
  }, t.timeouts = function(r) {
    if (r instanceof Array)
      return [].concat(r);
    var n = {
      retries: 10,
      factor: 2,
      minTimeout: 1 * 1e3,
      maxTimeout: 1 / 0,
      randomize: !1
    };
    for (var s in r)
      n[s] = r[s];
    if (n.minTimeout > n.maxTimeout)
      throw new Error("minTimeout is greater than maxTimeout");
    for (var i = [], o = 0; o < n.retries; o++)
      i.push(this.createTimeout(o, n));
    return r && r.forever && !i.length && i.push(this.createTimeout(o, n)), i.sort(function(a, c) {
      return a - c;
    }), i;
  }, t.createTimeout = function(r, n) {
    var s = n.randomize ? Math.random() + 1 : 1, i = Math.round(s * Math.max(n.minTimeout, 1) * Math.pow(n.factor, r));
    return i = Math.min(i, n.maxTimeout), i;
  }, t.wrap = function(r, n, s) {
    if (n instanceof Array && (s = n, n = null), !s) {
      s = [];
      for (var i in r)
        typeof r[i] == "function" && s.push(i);
    }
    for (var o = 0; o < s.length; o++) {
      var a = s[o], c = r[a];
      r[a] = function(l) {
        var p = t.operation(n), T = Array.prototype.slice.call(arguments, 1), rt = T.pop();
        T.push(function(ae) {
          p.retry(ae) || (ae && (arguments[0] = p.mainError()), rt.apply(this, arguments));
        }), p.attempt(function() {
          l.apply(r, T);
        });
      }.bind(r, c), r[a].options = n;
    }
  };
})(Le);
var Et = Le;
const yt = /* @__PURE__ */ _t(Et), Mt = Object.prototype.toString, Ct = (t) => Mt.call(t) === "[object Error]", bt = /* @__PURE__ */ new Set([
  "network error",
  // Chrome
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari 16
  "Load failed",
  // Safari 17+
  "Network request failed",
  // `cross-fetch`
  "fetch failed",
  // Undici (Node.js)
  "terminated"
  // Undici (Node.js)
]);
function Ot(t) {
  return t && Ct(t) && t.name === "TypeError" && typeof t.message == "string" ? t.message === "Load failed" ? t.stack === void 0 : bt.has(t.message) : !1;
}
class It extends Error {
  constructor(e) {
    super(), e instanceof Error ? (this.originalError = e, { message: e } = e) : (this.originalError = new Error(e), this.originalError.stack = this.stack), this.name = "AbortError", this.message = e;
  }
}
const ge = (t, e, r) => {
  const n = r.retries - (e - 1);
  return t.attemptNumber = e, t.retriesLeft = n, t;
};
function Rt(t, e) {
  return u(this, null, function* () {
    return new Promise((r, n) => {
      e = S({
        onFailedAttempt() {
        },
        retries: 10,
        shouldRetry: () => !0
      }, e);
      const s = yt.operation(e), i = () => {
        var a;
        s.stop(), n((a = e.signal) == null ? void 0 : a.reason);
      };
      e.signal && !e.signal.aborted && e.signal.addEventListener("abort", i, { once: !0 });
      const o = () => {
        var a;
        (a = e.signal) == null || a.removeEventListener("abort", i), s.stop();
      };
      s.attempt((a) => u(this, null, function* () {
        try {
          const c = yield t(a);
          o(), r(c);
        } catch (c) {
          try {
            if (!(c instanceof Error))
              throw new TypeError(`Non-error was thrown: "${c}". You should only throw errors.`);
            if (c instanceof It)
              throw c.originalError;
            if (c instanceof TypeError && !Ot(c))
              throw c;
            if (ge(c, a, e), (yield e.shouldRetry(c)) || (s.stop(), n(c)), yield e.onFailedAttempt(c), !s.retry(c))
              throw s.mainError();
          } catch (h) {
            ge(h, a, e), o(), n(h);
          }
        }
      }));
    });
  });
}
class Ae {
  static request(e, r, n = !0, s = 3) {
    return Rt(() => u(this, null, function* () {
      return yield fetch(e, S({
        headers: S({}, r.headers),
        credentials: "include"
      }, r)).then(n ? Tt : Re);
    }), {
      shouldRetry: (o) => o instanceof Ie && o.status >= 500,
      retries: s
    });
  }
}
const Lt = ["code"], At = ["post_message", "query"], Nt = ["S256"], Pt = ["authorization_code", "refresh_token"];
class Ut {
  constructor({ issuer: e, cacheStorage: r }) {
    this._openIdConfig = null, this.logger = g.createLogger(f.OIDC_CONFIG_MANAGER), this._issuer = e, this.cacheStorage = r, this.fetchOpenIdConfig();
  }
  /**
   * Fetches the OIDC configuration from the .well-known/openid-configuration endpoint
   * Caches the response for subsequent calls
   * @private
   */
  get openIdConfig() {
    return this._openIdConfig ? Promise.resolve(this._openIdConfig) : (this.logger.debug("OIDC config not cached"), this.fetchOpenIdConfig());
  }
  fetchOpenIdConfig() {
    this.logger.debug("Fetching OIDC config");
    const e = this.cacheStorage.getItem(ue.OIDC_CONFIGURATION);
    try {
      if (e && e.expiresAt > Date.now() && e.config.issuer === this._issuer)
        return this.logger.debug("Restoring OIDC configuration from cache"), this._openIdConfig = this.validate(e.config), Promise.resolve(this._openIdConfig);
    } catch (r) {
      this.logger.info("Cached OIDC configuration is missing, invalid, or expired. Refreshing");
    }
    return Ae.request(`${this._issuer}/.well-known/openid-configuration`, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }).then((r) => {
      this._openIdConfig = this.validate(r);
      const n = {
        // expires in an hour
        expiresAt: Date.now() + 60 * 60 * 1e3,
        config: r
      };
      return this.cacheStorage.setItem(ue.OIDC_CONFIGURATION, n), this._openIdConfig;
    });
  }
  /**
   * Validate the OIDC configuration against our supported response types
   * If none of our supported response types are supported by the server, throw an error
   *
   * @param config
   * @private
   */
  validate(e) {
    if (typeof e != "object" || e === null)
      throw new d("Invalid OIDC configuration");
    this.logger.debug("Validating OIDC config");
    const r = Lt.filter(
      (o) => {
        var a;
        return (a = e.response_types_supported) == null ? void 0 : a.includes(o);
      }
    );
    b(r.length > 0, "No supported response types");
    const n = At.filter(
      (o) => {
        var a;
        return (a = e.response_modes_supported) == null ? void 0 : a.includes(o);
      }
    );
    b(n.length > 0, "No supported response modes");
    const s = Nt.filter(
      (o) => {
        var a;
        return (a = e.code_challenge_methods_supported) == null ? void 0 : a.includes(o);
      }
    );
    b(s.length > 0, "No supported code challenge methods");
    const i = Pt.filter((o) => {
      var a;
      return (a = e.grant_types_supported) == null ? void 0 : a.includes(o);
    });
    return b(i.length > 0, "No supported grant types"), this.logger.debug("OIDC config validated successfully"), $(S({}, e), {
      response_types_supported: r,
      response_modes_supported: n,
      code_challenge_methods_supported: s,
      grant_types_supported: i
    });
  }
  /**
   * Uses the OIDC configuration to get the issuer url
   *
   */
  issuer() {
    return u(this, null, function* () {
      return (yield this.openIdConfig).issuer;
    });
  }
  /**
   * Uses the OIDC configuration to get the authorization endpoint.
   */
  authorizationUrl() {
    return u(this, null, function* () {
      return (yield this.openIdConfig).authorization_endpoint;
    });
  }
  /**
   * Uses the OIDC configuration to get the end session endpoint
   */
  endSessionUrl() {
    return u(this, null, function* () {
      return (yield this.openIdConfig).end_session_endpoint;
    });
  }
  /**
   * Uses the OIDC configuration to get the token endpoint.
   * Uses the issuer as the base url.
   */
  tokenUrl() {
    return u(this, null, function* () {
      return (yield this.openIdConfig).token_endpoint;
    });
  }
  userInfoUrl() {
    return u(this, null, function* () {
      return (yield this.openIdConfig).userinfo_endpoint;
    });
  }
  _checkFieldSupported(e, r) {
    return u(this, null, function* () {
      return this.openIdConfig.then((n) => {
        const s = n[e];
        return b(s.includes(r), `Unsupported ${e}: '${r}'`), r;
      });
    });
  }
  /**
   * Validates a given response type against the OIDC configuration
   * @param responseType
   */
  responseType(e) {
    return this._checkFieldSupported("response_types_supported", e);
  }
  /**
   * Validates a given response mode against the OIDC configuration
   * @param responseMode
   */
  responseMode(e) {
    return this._checkFieldSupported("response_modes_supported", e);
  }
  /**
   * Validates a given code challenge method against the OIDC configuration
   * @param codeChallengeMethod
   */
  codeChallengeMethod(e) {
    return this._checkFieldSupported("code_challenge_methods_supported", e);
  }
  /**
   * Validates a given grant type against the OIDC configuration
   * @param grantType
   */
  grantType(e) {
    return this._checkFieldSupported("grant_types_supported", e);
  }
}
const fe = {
  JSON: "application/json",
  FORM: "application/x-www-form-urlencoded"
};
class xt {
  constructor({ oidcManager: e, issuer: r }) {
    this.requiredHeaders = {
      Accept: fe.JSON
      // TODO: Enable version header when we have it whitelisted (header name may change)
      // 'X-Auth-SDK-Version': __MAP_SSO_SDK_VERSION__,
    }, this.logger = g.createLogger(f.ROUTER), this.oidcManager = e, this.issuer = r, this.clientHeaders = {};
  }
  setHeaders(e) {
    this.clientHeaders = e;
  }
  /**
   * Returns a URL the client can use to redirect to the login page.
   * Will have all the appropriate query parameters set for an OIDC/OAUth2
   * PKCE redirection flow.
   *
   * @param request
   */
  login(e) {
    return u(this, null, function* () {
      this.logger.debug("Starting login request");
      const r = yield this.oidcManager.authorizationUrl(), n = new URL(r), s = this.cleanSearchParams(e);
      return n.search = s.toString(), n;
    });
  }
  /**
   * Returns a URL the client can use to redirect to the logout page.
   * Will have all the appropriate query parameters set for an OIDC/OAUth2
   * RP-initiated logout flow.
   *
   * @param request
   */
  logout(e) {
    return u(this, null, function* () {
      this.logger.debug("Starting logout request");
      const r = yield this.oidcManager.endSessionUrl(), n = new URL(r), s = this.cleanSearchParams(e);
      return n.search = s.toString(), n;
    });
  }
  /**
   * Used to fetch an access token. Supports the following grant types:
   * - authorization_code
   * - refresh_token
   * See V2TokenRequest type for parameters required for each grant type.
   * @param request
   * @throws {NetworkError}
   */
  token(e) {
    return u(this, null, function* () {
      const r = yield this.oidcManager.tokenUrl(), n = this.cleanSearchParams(e);
      return this.exec(r, {
        method: "POST",
        body: n,
        headers: {
          "Content-Type": fe.FORM
        }
      });
    });
  }
  /**
   * Given a location, attempts to parse the authorization code and state from the location.
   * Will throw an error if the location does not contain both code and state query parameters.
   *
   * @param location
   * @throws { AuthorizationError }
   */
  parseRedirectUrl(e = window.location.href) {
    const r = new URL(e), n = new URLSearchParams(r.search), s = n.get("code"), i = n.get("state");
    if (!s || !i)
      throw this.logger.error("Could not parse authorization code from url", { location: e }), new j("MissingAuthorizationCode", "Could not parse redirect parameters from url");
    return { code: s, state: i };
  }
  /**
   * Checks the user has a valid session. This will return a 200 if the user has a valid session,
   * and a 401 if the user does not have a valid session.
   * @param accessToken
   */
  checkSession(r) {
    return u(this, arguments, function* ({ accessToken: e }) {
      const n = yield this.oidcManager.issuer();
      try {
        return yield this.exec(
          `${n}/oauth2/v1/checkSession`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${e}`
            }
          },
          !1
        ), !0;
      } catch (s) {
        return !1;
      }
    });
  }
  /**
   * Returns the active session for a user.
   * Requires third-party cookies to be enabled
   * @throws {NetworkError}
   */
  me() {
    return u(this, null, function* () {
      const e = yield this.oidcManager.issuer();
      return this.exec(`${e}/api/v1/sessions/me`, {
        method: "GET",
        credentials: "include"
      });
    });
  }
  deleteMe() {
    return u(this, null, function* () {
      const e = yield this.oidcManager.issuer();
      return this.exec(`${e}/api/v1/sessions/me`, { method: "DELETE", credentials: "include" }, !1);
    });
  }
  /**
   * Returns the user info from the SSO service.
   * @param accessToken
   * @throws {NetworkError}
   */
  userInfo(r) {
    return u(this, arguments, function* ({ accessToken: e }) {
      return this.exec(yield this.oidcManager.userInfoUrl(), {
        method: "GET",
        headers: {
          Authorization: `Bearer ${e}`
        }
      });
    });
  }
  /**
   * Executes a fetch request with the given url and request options.
   * Utilizes RequestUtil to set credentials and attempt retries on network failure.
   * @param url The url to fetch
   * @param req  The request options. Compatible with the fetch API.
   * @param parse Whether to parse the response as JSON. Defaults to true.
   * @throws {NetworkError}
   */
  exec(e, r, n = !0) {
    return u(this, null, function* () {
      return Ae.request(
        e,
        $(S({}, r), { headers: S(S(S({}, this.clientHeaders), this.requiredHeaders), r.headers) }),
        n
      );
    });
  }
  /**
   * Cleans the search params object by removing any undefined or null values as these
   * are serialized as string literals `undefined` and `null` which can have unintended consequences
   * @param searchParams
   * @private
   */
  cleanSearchParams(e) {
    const r = new URLSearchParams();
    return Object.entries(e).forEach(([n, s]) => {
      s != null && r.append(n, s);
    }), r;
  }
}
let F;
class Dt {
  constructor() {
    F = /* @__PURE__ */ new Map();
  }
  setItem(e, r) {
    F.set(e, r);
  }
  getItem(e) {
    var r;
    return (r = F.get(e)) != null ? r : null;
  }
  removeItem(e) {
    F.delete(e);
  }
}
const $t = new Dt();
function I() {
  return typeof document != "undefined" && typeof window != "undefined";
}
/*! js-cookie v3.0.5 | MIT */
function G(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e];
    for (var n in r)
      t[n] = r[n];
  }
  return t;
}
var Kt = {
  read: function(t) {
    return t[0] === '"' && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(t) {
    return encodeURIComponent(t).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function ee(t, e) {
  function r(s, i, o) {
    if (typeof document != "undefined") {
      o = G({}, e, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), s = encodeURIComponent(s).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var c in o)
        o[c] && (a += "; " + c, o[c] !== !0 && (a += "=" + o[c].split(";")[0]));
      return document.cookie = s + "=" + t.write(i, s) + a;
    }
  }
  function n(s) {
    if (!(typeof document == "undefined" || arguments.length && !s)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, a = 0; a < i.length; a++) {
        var c = i[a].split("="), h = c.slice(1).join("=");
        try {
          var l = decodeURIComponent(c[0]);
          if (o[l] = t.read(h, l), s === l)
            break;
        } catch (p) {
        }
      }
      return s ? o[s] : o;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(s, i) {
        r(
          s,
          "",
          G({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(s) {
        return ee(this.converter, G({}, this.attributes, s));
      },
      withConverter: function(s) {
        return ee(G({}, this.converter, s), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(e) },
      converter: { value: Object.freeze(t) }
    }
  );
}
var V = ee(Kt, { path: "/" });
class Bt {
  constructor(e) {
    this.cookieOptions = e;
  }
  /**
   * Cookies have size limitations, so we have to split incoming values into separate cookies.
   * value should be a JSON parsable object. Each key in the object will be stored as a separate cookie.
   *
   * @param key
   * @param value
   */
  setItem(e, r) {
    var a, c;
    const n = JSON.parse(this.getItem(e) || "{}"), s = JSON.parse(r), i = this.cookieOptions.sessionCookie ? null : (c = (a = this.cookieOptions.expires) == null ? void 0 : a.toUTCString()) != null ? c : null, o = new Set(
      Object.keys(s).map((h) => {
        const l = `${e}_${h}`, p = window.btoa(JSON.stringify(s[h]));
        return H.set(l, p, i, this.cookieOptions), h;
      })
    );
    Object.keys(n).filter((h) => !o.has(h)).forEach((h) => {
      H.delete(`${e}_${h}`);
    });
  }
  getItem(e) {
    const r = H.get(), n = Object.keys(r).filter((s) => s.startsWith(e)).map((s) => [s.replace(`${e}_`, ""), JSON.parse(window.atob(r[s]))]);
    return n.length === 0 ? null : JSON.stringify(Object.fromEntries(n));
  }
  removeItem(e) {
    const r = JSON.parse(this.getItem(e) || "{}");
    Object.keys(r).forEach((n) => {
      H.delete(`${e}_${n}`);
    });
  }
}
class H {
  static get(e) {
    return e ? V.get(e) : V.get();
  }
  static set(e, r, n, s) {
    const { sameSite: i, secure: o } = s;
    if (typeof o == "undefined" || typeof i == "undefined")
      throw new d('CookieStorage: "secure" and "sameSite" cookie options must be provided');
    const a = {
      path: s.path || "/",
      secure: o,
      sameSite: i
    };
    n && Date.parse(n) && (a.expires = new Date(n)), V.set(e, r, a);
    const c = this.get(e);
    if (!c)
      throw new d(`CookieStorage: Unable to set cookie ${e}`);
    return c;
  }
  static delete(e) {
    V.remove(e, { path: "/" });
  }
}
const Ft = {
  /**
   * Given a list of storage types, it will test each in order
   * and return the first available storage type.
   *
   * @param storageTypes
   * @throws {AuthSdkError} - No compatible storage type found
   */
  findStorageType(t) {
    const e = t.find((r) => {
      const n = g.createLogger(f.STORAGE_UTILS), s = this.testStorageType(r);
      return s || n.warn(`Storage type ${r} is not supported`), s;
    });
    if (!e)
      throw new d("No storage type available");
    return e;
  },
  /**
   * Returns a storage interface for the given storage type.
   * @param storageType
   * @param cookieOptions
   */
  getStorageByType(t, e) {
    switch (t) {
      case "localStorage":
        return this.getLocalStorage();
      case "sessionStorage":
        return this.getSessionStorage();
      case "cookie":
        return this.getCookieStorage(e);
      case "memory":
        return $t;
      default:
        return W(t, new d(`Unknown storage type: ${t}`));
    }
  },
  /**
   * Tests whether the given storage type is supported.
   * @param storageType
   */
  testStorageType(t) {
    switch (t) {
      case "localStorage":
        return Gt();
      case "sessionStorage":
        return Vt();
      case "cookie":
      case "memory":
        return !0;
      default:
        return W(t, new d(`Unknown storage type: ${t}`));
    }
  },
  getLocalStorage() {
    return window.localStorage;
  },
  getSessionStorage() {
    return window.sessionStorage;
  },
  getCookieStorage(t) {
    return t.path || (t.path = "/"), t.secure || (t.secure = !0), t.sameSite || (t.sameSite = t.secure ? "none" : "lax"), t.expires || (t.expires = t.sessionCookie ? void 0 : new Date(Date.now() + lt)), new Bt(t);
  }
};
function Ne(t) {
  try {
    return t.setItem(y.TEST, y.TEST), b(t.getItem(y.TEST) === y.TEST), t.removeItem(y.TEST), !0;
  } catch (e) {
    return !1;
  }
}
function Gt() {
  try {
    return I() && Ne(window.localStorage);
  } catch (t) {
    return !1;
  }
}
function Vt() {
  try {
    return I() && Ne(window.sessionStorage);
  } catch (t) {
    return !1;
  }
}
const pe = "{}";
class X {
  constructor(e, r) {
    this.storage = e, this.storageKey = r;
  }
  /**
   * Updates the entire stored value with a serialized version of the input.
   * @param obj
   * @throws {AuthSdkError} - There is a problem stringifying or saving the object
   */
  setStorage(e) {
    try {
      const r = JSON.stringify(e != null ? e : pe);
      this.storage.setItem(this.storageKey, r);
    } catch (r) {
      throw new d(`Unable to set storage: ${this.storageKey}
`, r);
    }
  }
  /**
   * Returns the entire stored value and attempts to parse it to an object
   * @throws {AuthSdkError} - Unable to parse stored value
   */
  getStorage() {
    var e;
    try {
      const r = (e = this.storage.getItem(this.storageKey)) != null ? e : pe;
      return typeof r == "string" ? JSON.parse(r) : r;
    } catch (r) {
      throw new d(`Unable to parse stored object: ${this.storageKey}`, r);
    }
  }
  /**
   * Used for clearing values from the store.
   * If a key is provided, only that key will be removed.
   * If no key is provided, the entire store will be cleared.
   * @param key
   */
  clearStorage(e) {
    if (!e) {
      this.storage.removeItem(this.storageKey);
      return;
    }
    const r = this.getStorage();
    delete r[e], this.setStorage(r);
  }
  /**
   * Used for updating a single value in the store.
   * @param key
   * @param value
   */
  updateStorage(e, r) {
    const n = this.getStorage();
    n[e] = r, this.setStorage(n);
  }
  /**
   * Compat with SimpleStorage interface
   * @param key
   * @param value
   */
  setItem(e, r) {
    return this.updateStorage(e, r);
  }
  /**
   * Compat with SimpleStorage interface
   * @param key
   */
  getItem(e) {
    var r, n;
    return (n = (r = this.getStorage()) == null ? void 0 : r[e]) != null ? n : null;
  }
  /**
   * Compat with SimpleStorage interface
   * @param key
   */
  removeItem(e) {
    return this.clearStorage(e);
  }
}
const Pe = {
  token: {
    storageTypes: ["localStorage", "sessionStorage", "cookie", "memory"]
  },
  cache: {
    storageTypes: ["localStorage", "sessionStorage", "memory"]
  },
  transaction: {
    storageTypes: ["sessionStorage", "cookie"]
  }
}, q = class q {
  constructor(e = q.DEFAULT_RULES, r = {}, n = Ft) {
    this.rules = Ht(e), this.cookieOptions = r, this.utils = n;
  }
  getOptionsForSection(e) {
    return this.rules[e];
  }
  getOptionsForRuleset({ storageProvider: e, storageTypes: r, storageType: n }) {
    const s = Object.assign({}, this.cookieOptions);
    if (e)
      return e;
    if (n === "sessionStorage" && (s.sessionCookie = !0), n && r) {
      const i = r.indexOf(n);
      i >= 0 && (r = r.slice(i), n = void 0);
    }
    return n || (n = this.utils.findStorageType(r != null ? r : [])), this.utils.getStorageByType(n, s);
  }
  /**
   * Returns a StorageProvider for the token storage type.
   */
  getTokenStorage() {
    const e = this.getOptionsForSection("token"), r = this.getOptionsForRuleset(e);
    return new X(r, y.TOKENS);
  }
  /**
   * Returns a StorageProvider for the cache storage type.
   */
  getCacheStorage() {
    const e = this.getOptionsForSection("cache"), r = this.getOptionsForRuleset(e);
    return new X(r, y.CACHE);
  }
  /**
   * Returns a StorageProvider for the transaction storage type.
   */
  getTransactionStorage() {
    const e = this.getOptionsForSection("transaction"), r = this.getOptionsForRuleset(e);
    return new X(r, y.TRANSACTION);
  }
};
q.DEFAULT_RULES = Pe;
let te = q;
function Ht(t) {
  return Object.fromEntries(
    Object.entries(Pe).map(([e, r]) => {
      const n = t[e];
      return [e, S(S({}, r), n)];
    })
  );
}
class jt {
  constructor({ transformAuthState: e, sdk: r }) {
    this.logger = g.createLogger(f.AUTH_STATE_MANAGER), this.emitter = ye(), this.authState = null, this.previousAuthState = null, this.sdk = r, this.transformAuthState = e;
  }
  /**
   * Returns the current auth state. If the auth state has not been initialized yet, returns null.
   * Note that the auth state is updated asynchronously, so calls to update the auth state will need
   * to be awaited prior to this value changing.
   */
  getAuthState() {
    return this.authState;
  }
  /**
   * Returns the previous auth state. If the auth state has not been initialized yet, returns null.
   */
  getPreviousAuthState() {
    return this.previousAuthState;
  }
  /**
   * Subscribe to auth state change events. Handlers will be called with an sdk instance and the changed auth state
   * @param event
   * @param handler
   */
  subscribe(e, r) {
    this.emitter.on(e, r);
  }
  /**
   * Unsubscribe to auth state change events. Must provide the original handler passed to subscribe()
   * @param event
   * @param handler
   */
  unsubscribe(e, r) {
    this.emitter.off(e, r);
  }
  /**
   * Asynchronously updates the auth state and emits an event with the new auth state.
   * Will also resolve with the new auth state.
   *
   * If a transformAuthState function was provided, the auth state will be passed to that function before being emitted. This allows you to add custom properties, or change the existing values
   * of the auth state before they are emitted.
   *
   * If auth states are the same, no changes will be emitted. Please note that comparison does not include any custom properties added by the transformAuthState function.
   */
  updateAuthState() {
    return u(this, null, function* () {
      var o;
      this.logger.debug("Starting auth state update");
      const { accessToken: e, refreshToken: r, idToken: n } = (o = this.sdk.tokenManager.getTokens()) != null ? o : {}, s = this.sdk.tokenManager.hasExpired(e), i = this.sdk.tokenManager.hasExpired(n);
      try {
        const a = {
          isAuthenticated: !s && !i,
          accessToken: e,
          refreshToken: r,
          idToken: n
        }, c = yield this.transformAuthState ? this.transformAuthState(this.sdk, a) : Promise.resolve(a);
        return this.emitAuthStateChange(c), c;
      } catch (a) {
        this.logger.error("Could not transform auth state", a);
        const c = {
          isAuthenticated: !1,
          error: a
        };
        return this.emitAuthStateChange(c), c;
      }
    });
  }
  /**
   * Determines whether an auth state change should be emitted.
   * If the state has changed, updates the authState and previousAuthState values
   * @param newAuthState
   * @private
   */
  emitAuthStateChange(e) {
    if (Wt(this.authState, e)) {
      this.logger.debug("Auth state unchanged");
      return;
    }
    this.previousAuthState = this.authState, this.authState = e, this.logger.debug("Emitting authStateChange event", e), this.emitter.emit("authStateChange", e);
  }
}
function Wt(t, e) {
  return t === null ? !1 : t.isAuthenticated === (e == null ? void 0 : e.isAuthenticated) && t.accessToken === (e == null ? void 0 : e.accessToken) && t.idToken === (e == null ? void 0 : e.idToken) && t.error === (e == null ? void 0 : e.error);
}
const qt = /\bopenid\b/gm;
function Ue(t) {
  return t.match(qt) ? t.trim() : `openid ${t}`.trim();
}
function Jt(t) {
  return t && typeof t.then == "function";
}
Promise.resolve(!1);
var zt = Promise.resolve(!0), _ = Promise.resolve();
function M(t, e) {
  return t || (t = 0), new Promise(function(r) {
    return setTimeout(function() {
      return r(e);
    }, t);
  });
}
function Qt(t, e) {
  return Math.floor(Math.random() * (e - t + 1) + t);
}
function x() {
  return Math.random().toString(36).substring(2);
}
var Z = 0;
function D() {
  var t = Date.now() * 1e3;
  return t <= Z && (t = Z + 1), Z = t, t;
}
function Yt() {
  return typeof navigator != "undefined" && typeof navigator.locks != "undefined" && typeof navigator.locks.request == "function";
}
var Xt = D, Zt = "native";
function er(t) {
  var e = {
    time: D(),
    messagesCallback: null,
    bc: new BroadcastChannel(t),
    subFns: []
    // subscriberFunctions
  };
  return e.bc.onmessage = function(r) {
    e.messagesCallback && e.messagesCallback(r.data);
  }, e;
}
function tr(t) {
  t.bc.close(), t.subFns = [];
}
function rr(t, e) {
  try {
    return t.bc.postMessage(e, !1), _;
  } catch (r) {
    return Promise.reject(r);
  }
}
function nr(t, e) {
  t.messagesCallback = e;
}
function sr() {
  if (typeof globalThis != "undefined" && globalThis.Deno && globalThis.Deno.args)
    return !0;
  if ((typeof window != "undefined" || typeof self != "undefined") && typeof BroadcastChannel == "function") {
    if (BroadcastChannel._pubkey)
      throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
    return !0;
  } else
    return !1;
}
function ir() {
  return 150;
}
var or = {
  create: er,
  close: tr,
  onMessage: nr,
  postMessage: rr,
  canBeUsed: sr,
  type: Zt,
  averageResponseTime: ir,
  microSeconds: Xt
};
class xe {
  constructor(e) {
    K(this, "ttl");
    K(this, "map", /* @__PURE__ */ new Map());
    /**
     * Creating calls to setTimeout() is expensive,
     * so we only do that if there is not timeout already open.
     */
    K(this, "_to", !1);
    this.ttl = e;
  }
  has(e) {
    return this.map.has(e);
  }
  add(e) {
    this.map.set(e, De()), this._to || (this._to = !0, setTimeout(() => {
      this._to = !1, ar(this);
    }, 0));
  }
  clear() {
    this.map.clear();
  }
}
function ar(t) {
  const e = De() - t.ttl, r = t.map[Symbol.iterator]();
  for (; ; ) {
    const n = r.next().value;
    if (!n)
      return;
    const s = n[0];
    if (n[1] < e)
      t.map.delete(s);
    else
      return;
  }
}
function De() {
  return Date.now();
}
function se() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = JSON.parse(JSON.stringify(t));
  return typeof e.webWorkerSupport == "undefined" && (e.webWorkerSupport = !0), e.idb || (e.idb = {}), e.idb.ttl || (e.idb.ttl = 1e3 * 45), e.idb.fallbackInterval || (e.idb.fallbackInterval = 150), t.idb && typeof t.idb.onclose == "function" && (e.idb.onclose = t.idb.onclose), e.localstorage || (e.localstorage = {}), e.localstorage.removeTimeout || (e.localstorage.removeTimeout = 1e3 * 60), t.methods && (e.methods = t.methods), e.node || (e.node = {}), e.node.ttl || (e.node.ttl = 1e3 * 60 * 2), e.node.maxParallelWrites || (e.node.maxParallelWrites = 2048), typeof e.node.useFastPath == "undefined" && (e.node.useFastPath = !0), e;
}
var cr = D, ur = "pubkey.broadcast-channel-0-", k = "messages", z = {
  durability: "relaxed"
}, hr = "idb";
function $e() {
  if (typeof indexedDB != "undefined") return indexedDB;
  if (typeof window != "undefined") {
    if (typeof window.mozIndexedDB != "undefined") return window.mozIndexedDB;
    if (typeof window.webkitIndexedDB != "undefined") return window.webkitIndexedDB;
    if (typeof window.msIndexedDB != "undefined") return window.msIndexedDB;
  }
  return !1;
}
function ie(t) {
  t.commit && t.commit();
}
function dr(t) {
  var e = $e(), r = ur + t, n = e.open(r);
  return n.onupgradeneeded = function(s) {
    var i = s.target.result;
    i.createObjectStore(k, {
      keyPath: "id",
      autoIncrement: !0
    });
  }, new Promise(function(s, i) {
    n.onerror = function(o) {
      return i(o);
    }, n.onsuccess = function() {
      s(n.result);
    };
  });
}
function lr(t, e, r) {
  var n = Date.now(), s = {
    uuid: e,
    time: n,
    data: r
  }, i = t.transaction([k], "readwrite", z);
  return new Promise(function(o, a) {
    i.oncomplete = function() {
      return o();
    }, i.onerror = function(h) {
      return a(h);
    };
    var c = i.objectStore(k);
    c.add(s), ie(i);
  });
}
function gr(t, e) {
  var r = t.transaction(k, "readonly", z), n = r.objectStore(k), s = [], i = IDBKeyRange.bound(e + 1, 1 / 0);
  if (n.getAll) {
    var o = n.getAll(i);
    return new Promise(function(c, h) {
      o.onerror = function(l) {
        return h(l);
      }, o.onsuccess = function(l) {
        c(l.target.result);
      };
    });
  }
  function a() {
    try {
      return i = IDBKeyRange.bound(e + 1, 1 / 0), n.openCursor(i);
    } catch (c) {
      return n.openCursor();
    }
  }
  return new Promise(function(c, h) {
    var l = a();
    l.onerror = function(p) {
      return h(p);
    }, l.onsuccess = function(p) {
      var T = p.target.result;
      T ? T.value.id < e + 1 ? T.continue(e + 1) : (s.push(T.value), T.continue()) : (ie(r), c(s));
    };
  });
}
function fr(t, e) {
  if (t.closed)
    return Promise.resolve([]);
  var r = t.db.transaction(k, "readwrite", z), n = r.objectStore(k);
  return Promise.all(e.map(function(s) {
    var i = n.delete(s);
    return new Promise(function(o) {
      i.onsuccess = function() {
        return o();
      };
    });
  }));
}
function pr(t, e) {
  var r = Date.now() - e, n = t.transaction(k, "readonly", z), s = n.objectStore(k), i = [];
  return new Promise(function(o) {
    s.openCursor().onsuccess = function(a) {
      var c = a.target.result;
      if (c) {
        var h = c.value;
        h.time < r ? (i.push(h), c.continue()) : (ie(n), o(i));
      } else
        o(i);
    };
  });
}
function mr(t) {
  return pr(t.db, t.options.idb.ttl).then(function(e) {
    return fr(t, e.map(function(r) {
      return r.id;
    }));
  });
}
function Sr(t, e) {
  return e = se(e), dr(t).then(function(r) {
    var n = {
      closed: !1,
      lastCursorId: 0,
      channelName: t,
      options: e,
      uuid: x(),
      /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */
      eMIs: new xe(e.idb.ttl * 2),
      // ensures we do not read messages in parallel
      writeBlockPromise: _,
      messagesCallback: null,
      readQueuePromises: [],
      db: r
    };
    return r.onclose = function() {
      n.closed = !0, e.idb.onclose && e.idb.onclose();
    }, Ke(n), n;
  });
}
function Ke(t) {
  t.closed || Be(t).then(function() {
    return M(t.options.idb.fallbackInterval);
  }).then(function() {
    return Ke(t);
  });
}
function wr(t, e) {
  return !(t.uuid === e.uuid || e.eMIs.has(t.id) || t.data.time < e.messagesCallbackTime);
}
function Be(t) {
  return t.closed || !t.messagesCallback ? _ : gr(t.db, t.lastCursorId).then(function(e) {
    var r = e.filter(function(n) {
      return !!n;
    }).map(function(n) {
      return n.id > t.lastCursorId && (t.lastCursorId = n.id), n;
    }).filter(function(n) {
      return wr(n, t);
    }).sort(function(n, s) {
      return n.time - s.time;
    });
    return r.forEach(function(n) {
      t.messagesCallback && (t.eMIs.add(n.id), t.messagesCallback(n.data));
    }), _;
  });
}
function vr(t) {
  t.closed = !0, t.db.close();
}
function Tr(t, e) {
  return t.writeBlockPromise = t.writeBlockPromise.then(function() {
    return lr(t.db, t.uuid, e);
  }).then(function() {
    Qt(0, 10) === 0 && mr(t);
  }), t.writeBlockPromise;
}
function _r(t, e, r) {
  t.messagesCallbackTime = r, t.messagesCallback = e, Be(t);
}
function kr() {
  return !!$e();
}
function Er(t) {
  return t.idb.fallbackInterval * 2;
}
var yr = {
  create: Sr,
  close: vr,
  onMessage: _r,
  postMessage: Tr,
  canBeUsed: kr,
  type: hr,
  averageResponseTime: Er,
  microSeconds: cr
}, Mr = D, Cr = "pubkey.broadcastChannel-", br = "localstorage";
function Fe() {
  var t;
  if (typeof window == "undefined") return null;
  try {
    t = window.localStorage, t = window["ie8-eventlistener/storage"] || window.localStorage;
  } catch (e) {
  }
  return t;
}
function Ge(t) {
  return Cr + t;
}
function Or(t, e) {
  return new Promise(function(r) {
    M().then(function() {
      var n = Ge(t.channelName), s = {
        token: x(),
        time: Date.now(),
        data: e,
        uuid: t.uuid
      }, i = JSON.stringify(s);
      Fe().setItem(n, i);
      var o = document.createEvent("Event");
      o.initEvent("storage", !0, !0), o.key = n, o.newValue = i, window.dispatchEvent(o), r();
    });
  });
}
function Ir(t, e) {
  var r = Ge(t), n = function(i) {
    i.key === r && e(JSON.parse(i.newValue));
  };
  return window.addEventListener("storage", n), n;
}
function Rr(t) {
  window.removeEventListener("storage", t);
}
function Lr(t, e) {
  if (e = se(e), !Ve())
    throw new Error("BroadcastChannel: localstorage cannot be used");
  var r = x(), n = new xe(e.localstorage.removeTimeout), s = {
    channelName: t,
    uuid: r,
    eMIs: n
    // emittedMessagesIds
  };
  return s.listener = Ir(t, function(i) {
    s.messagesCallback && i.uuid !== r && (!i.token || n.has(i.token) || i.data.time && i.data.time < s.messagesCallbackTime || (n.add(i.token), s.messagesCallback(i.data)));
  }), s;
}
function Ar(t) {
  Rr(t.listener);
}
function Nr(t, e, r) {
  t.messagesCallbackTime = r, t.messagesCallback = e;
}
function Ve() {
  var t = Fe();
  if (!t) return !1;
  try {
    var e = "__broadcastchannel_check";
    t.setItem(e, "works"), t.removeItem(e);
  } catch (r) {
    return !1;
  }
  return !0;
}
function Pr() {
  var t = 120, e = navigator.userAgent.toLowerCase();
  return e.includes("safari") && !e.includes("chrome") ? t * 2 : t;
}
var Ur = {
  create: Lr,
  close: Ar,
  onMessage: Nr,
  postMessage: Or,
  canBeUsed: Ve,
  type: br,
  averageResponseTime: Pr,
  microSeconds: Mr
}, He = D, xr = "simulate", oe = /* @__PURE__ */ new Set();
function Dr(t) {
  var e = {
    time: He(),
    name: t,
    messagesCallback: null
  };
  return oe.add(e), e;
}
function $r(t) {
  oe.delete(t);
}
var je = 5;
function Kr(t, e) {
  return new Promise(function(r) {
    return setTimeout(function() {
      var n = Array.from(oe);
      n.forEach(function(s) {
        s.name === t.name && // has same name
        s !== t && s.messagesCallback && // has subscribers
        s.time < e.time && s.messagesCallback(e);
      }), r();
    }, je);
  });
}
function Br(t, e) {
  t.messagesCallback = e;
}
function Fr() {
  return !0;
}
function Gr() {
  return je;
}
var Vr = {
  create: Dr,
  close: $r,
  onMessage: Br,
  postMessage: Kr,
  canBeUsed: Fr,
  type: xr,
  averageResponseTime: Gr,
  microSeconds: He
}, me = [
  or,
  // fastest
  yr,
  Ur
];
function Hr(t) {
  var e = [].concat(t.methods, me).filter(Boolean);
  if (t.type) {
    if (t.type === "simulate")
      return Vr;
    var r = e.find(function(s) {
      return s.type === t.type;
    });
    if (r) return r;
    throw new Error("method-type " + t.type + " not found");
  }
  t.webWorkerSupport || (e = e.filter(function(s) {
    return s.type !== "idb";
  }));
  var n = e.find(function(s) {
    return s.canBeUsed();
  });
  if (n)
    return n;
  throw new Error("No usable method found in " + JSON.stringify(me.map(function(s) {
    return s.type;
  })));
}
var We = /* @__PURE__ */ new Set(), jr = 0, Q = function(e, r) {
  this.id = jr++, We.add(this), this.name = e, Se && (r = Se), this.options = se(r), this.method = Hr(this.options), this._iL = !1, this._onML = null, this._addEL = {
    message: [],
    internal: []
  }, this._uMP = /* @__PURE__ */ new Set(), this._befC = [], this._prepP = null, Wr(this);
};
Q._pubkey = !0;
var Se;
Q.prototype = {
  postMessage: function(e) {
    if (this.closed)
      throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */
      JSON.stringify(e));
    return we(this, "message", e);
  },
  postInternal: function(e) {
    return we(this, "internal", e);
  },
  set onmessage(t) {
    var e = this.method.microSeconds(), r = {
      time: e,
      fn: t
    };
    Te(this, "message", this._onML), t && typeof t == "function" ? (this._onML = r, ve(this, "message", r)) : this._onML = null;
  },
  addEventListener: function(e, r) {
    var n = this.method.microSeconds(), s = {
      time: n,
      fn: r
    };
    ve(this, e, s);
  },
  removeEventListener: function(e, r) {
    var n = this._addEL[e].find(function(s) {
      return s.fn === r;
    });
    Te(this, e, n);
  },
  close: function() {
    var e = this;
    if (!this.closed) {
      We.delete(this), this.closed = !0;
      var r = this._prepP ? this._prepP : _;
      return this._onML = null, this._addEL.message = [], r.then(function() {
        return Promise.all(Array.from(e._uMP));
      }).then(function() {
        return Promise.all(e._befC.map(function(n) {
          return n();
        }));
      }).then(function() {
        return e.method.close(e._state);
      });
    }
  },
  get type() {
    return this.method.type;
  },
  get isClosed() {
    return this.closed;
  }
};
function we(t, e, r) {
  var n = t.method.microSeconds(), s = {
    time: n,
    type: e,
    data: r
  }, i = t._prepP ? t._prepP : _;
  return i.then(function() {
    var o = t.method.postMessage(t._state, s);
    return t._uMP.add(o), o.catch().then(function() {
      return t._uMP.delete(o);
    }), o;
  });
}
function Wr(t) {
  var e = t.method.create(t.name, t.options);
  Jt(e) ? (t._prepP = e, e.then(function(r) {
    t._state = r;
  })) : t._state = e;
}
function qe(t) {
  return t._addEL.message.length > 0 || t._addEL.internal.length > 0;
}
function ve(t, e, r) {
  t._addEL[e].push(r), qr(t);
}
function Te(t, e, r) {
  t._addEL[e] = t._addEL[e].filter(function(n) {
    return n !== r;
  }), Jr(t);
}
function qr(t) {
  if (!t._iL && qe(t)) {
    var e = function(s) {
      t._addEL[s.type].forEach(function(i) {
        s.time >= i.time && i.fn(s.data);
      });
    }, r = t.method.microSeconds();
    t._prepP ? t._prepP.then(function() {
      t._iL = !0, t.method.onMessage(t._state, e, r);
    }) : (t._iL = !0, t.method.onMessage(t._state, e, r));
  }
}
function Jr(t) {
  if (t._iL && !qe(t)) {
    t._iL = !1;
    var e = t.method.microSeconds();
    t.method.onMessage(t._state, null, e);
  }
}
function zr(t) {
  if (typeof WorkerGlobalScope == "function" && self instanceof WorkerGlobalScope) {
    var e = self.close.bind(self);
    self.close = function() {
      return t(), e();
    };
  } else {
    if (typeof window.addEventListener != "function")
      return;
    window.addEventListener("beforeunload", function() {
      t();
    }, !0), window.addEventListener("unload", function() {
      t();
    }, !0);
  }
}
function Qr(t) {
  process.on("exit", function() {
    return t();
  }), process.on("beforeExit", function() {
    return t().then(function() {
      return process.exit();
    });
  }), process.on("SIGINT", function() {
    return t().then(function() {
      return process.exit();
    });
  }), process.on("uncaughtException", function(e) {
    return t().then(function() {
      console.trace(e), process.exit(101);
    });
  });
}
var Yr = Object.prototype.toString.call(typeof process != "undefined" ? process : 0) === "[object process]", Xr = Yr ? Qr : zr, A = /* @__PURE__ */ new Set(), _e = !1;
function Zr() {
  _e || (_e = !0, Xr(tn));
}
function en(t) {
  if (Zr(), typeof t != "function")
    throw new Error("Listener is no function");
  A.add(t);
  var e = {
    remove: function() {
      return A.delete(t);
    },
    run: function() {
      return A.delete(t), t();
    }
  };
  return e;
}
function tn() {
  var t = [];
  return A.forEach(function(e) {
    t.push(e()), A.delete(e);
  }), Promise.all(t);
}
function C(t, e) {
  var r = {
    context: "leader",
    action: e,
    token: t.token
  };
  return t.broadcastChannel.postInternal(r);
}
function Je(t) {
  t.isLeader = !0, t._hasLeader = !0;
  var e = en(function() {
    return t.die();
  });
  t._unl.push(e);
  var r = function(s) {
    s.context === "leader" && s.action === "apply" && C(t, "tell"), s.context === "leader" && s.action === "tell" && !t._dpLC && (t._dpLC = !0, t._dpL(), C(t, "tell"));
  };
  return t.broadcastChannel.addEventListener("internal", r), t._lstns.push(r), C(t, "tell");
}
var ze = function(e, r) {
  var n = this;
  this.broadcastChannel = e, e._befC.push(function() {
    return n.die();
  }), this._options = r, this.isLeader = !1, this.isDead = !1, this.token = x(), this._lstns = [], this._unl = [], this._dpL = function() {
  }, this._dpLC = !1, this._wKMC = {}, this.lN = "pubkey-bc||" + e.method.type + "||" + e.name;
};
ze.prototype = {
  hasLeader: function() {
    var e = this;
    return navigator.locks.query().then(function(r) {
      var n = r.held ? r.held.filter(function(s) {
        return s.name === e.lN;
      }) : [];
      return !!(n && n.length > 0);
    });
  },
  awaitLeadership: function() {
    var e = this;
    if (!this._wLMP) {
      this._wKMC.c = new AbortController();
      var r = new Promise(function(n, s) {
        e._wKMC.res = n, e._wKMC.rej = s;
      });
      this._wLMP = new Promise(function(n) {
        navigator.locks.request(e.lN, {
          signal: e._wKMC.c.signal
        }, function() {
          return e._wKMC.c = void 0, Je(e), n(), r;
        }).catch(function() {
        });
      });
    }
    return this._wLMP;
  },
  set onduplicate(t) {
  },
  die: function() {
    var e = this;
    return this._lstns.forEach(function(r) {
      return e.broadcastChannel.removeEventListener("internal", r);
    }), this._lstns = [], this._unl.forEach(function(r) {
      return r.remove();
    }), this._unl = [], this.isLeader && (this.isLeader = !1), this.isDead = !0, this._wKMC.res && this._wKMC.res(), this._wKMC.c && this._wKMC.c.abort("LeaderElectionWebLock.die() called"), C(this, "death");
  }
};
var Qe = function(e, r) {
  var n = this;
  this.broadcastChannel = e, this._options = r, this.isLeader = !1, this._hasLeader = !1, this.isDead = !1, this.token = x(), this._aplQ = _, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function() {
  }, this._dpLC = !1;
  var s = function(o) {
    o.context === "leader" && (o.action === "death" && (n._hasLeader = !1), o.action === "tell" && (n._hasLeader = !0));
  };
  this.broadcastChannel.addEventListener("internal", s), this._lstns.push(s);
};
Qe.prototype = {
  hasLeader: function() {
    return Promise.resolve(this._hasLeader);
  },
  /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */
  applyOnce: function(e) {
    var r = this;
    if (this.isLeader)
      return M(0, !0);
    if (this.isDead)
      return M(0, !1);
    if (this._aplQC > 1)
      return this._aplQ;
    var n = function() {
      if (r.isLeader)
        return zt;
      var i = !1, o, a = new Promise(function(l) {
        o = function() {
          i = !0, l();
        };
      }), c = function(p) {
        p.context === "leader" && p.token != r.token && (p.action === "apply" && p.token > r.token && o(), p.action === "tell" && (o(), r._hasLeader = !0));
      };
      r.broadcastChannel.addEventListener("internal", c);
      var h = e ? r._options.responseTime * 4 : r._options.responseTime;
      return C(r, "apply").then(function() {
        return Promise.race([M(h), a.then(function() {
          return Promise.reject(new Error());
        })]);
      }).then(function() {
        return C(r, "apply");
      }).then(function() {
        return Promise.race([M(h), a.then(function() {
          return Promise.reject(new Error());
        })]);
      }).catch(function() {
      }).then(function() {
        return r.broadcastChannel.removeEventListener("internal", c), i ? !1 : Je(r).then(function() {
          return !0;
        });
      });
    };
    return this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function() {
      return n();
    }).then(function() {
      r._aplQC = r._aplQC - 1;
    }), this._aplQ.then(function() {
      return r.isLeader;
    });
  },
  awaitLeadership: function() {
    return this._aLP || (this._aLP = rn(this)), this._aLP;
  },
  set onduplicate(t) {
    this._dpL = t;
  },
  die: function() {
    var e = this;
    return this._lstns.forEach(function(r) {
      return e.broadcastChannel.removeEventListener("internal", r);
    }), this._lstns = [], this._unl.forEach(function(r) {
      return r.remove();
    }), this._unl = [], this.isLeader && (this._hasLeader = !1, this.isLeader = !1), this.isDead = !0, C(this, "death");
  }
};
function rn(t) {
  return t.isLeader ? _ : new Promise(function(e) {
    var r = !1;
    function n() {
      r || (r = !0, t.broadcastChannel.removeEventListener("internal", i), e(!0));
    }
    t.applyOnce().then(function() {
      t.isLeader && n();
    });
    var s = function o() {
      return M(t._options.fallbackInterval).then(function() {
        if (!(t.isDead || r))
          if (t.isLeader)
            n();
          else
            return t.applyOnce(!0).then(function() {
              t.isLeader ? n() : o();
            });
      });
    };
    s();
    var i = function(a) {
      a.context === "leader" && a.action === "death" && (t._hasLeader = !1, t.applyOnce().then(function() {
        t.isLeader && n();
      }));
    };
    t.broadcastChannel.addEventListener("internal", i), t._lstns.push(i);
  });
}
function nn(t, e) {
  return t || (t = {}), t = JSON.parse(JSON.stringify(t)), t.fallbackInterval || (t.fallbackInterval = 3e3), t.responseTime || (t.responseTime = e.method.averageResponseTime(e.options)), t;
}
function sn(t, e) {
  if (t._leaderElector)
    throw new Error("BroadcastChannel already has a leader-elector");
  e = nn(e, t);
  var r = Yt() ? new ze(t, e) : new Qe(t, e);
  return t._befC.push(function() {
    return r.die();
  }), t._leaderElector = r, r;
}
class on {
  constructor(e) {
    this.options = e, this.logger = g.createLogger(f.LEADER_ELECTION), this.started = !1, this.onLeader = this.onLeader.bind(this), this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this);
  }
  onLeader() {
    return u(this, null, function* () {
      var e, r;
      yield (r = (e = this.options).onLeader) == null ? void 0 : r.call(e);
    });
  }
  onLeaderDuplicate() {
    return u(this, null, function* () {
      this.logger.debug("Duplicate leader detected");
    });
  }
  isLeader() {
    var e;
    return !!((e = this.elector) != null && e.isLeader);
  }
  hasLeader() {
    return u(this, null, function* () {
      var e;
      return !!(yield (e = this.elector) == null ? void 0 : e.hasLeader());
    });
  }
  start() {
    return u(this, null, function* () {
      if (!this.canStart()) {
        this.logger.warn("Leader election cannot be started or is already running");
        return;
      }
      const { electionChannelName: e } = this.options;
      try {
        this.channel = new Q(e);
      } catch (r) {
        throw this.logger.debug(r), new d("Failed to create channel. LeaderElection is not supported in this browser");
      }
      this.elector = sn(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0;
    });
  }
  stop() {
    return u(this, null, function* () {
      if (!this.started) {
        this.logger.warn("Leader election already stopped");
        return;
      }
      this.elector && (yield this.elector.die(), this.elector = void 0), this.channel && (this.channel.postInternal = () => Promise.resolve(), yield this.channel.close(), this.channel = void 0), this.started = !1;
    });
  }
  isStarted() {
    return this.started;
  }
  canStart() {
    return !this.started && I();
  }
  /**
   * Exists to satisfy the Service interface.
   */
  requiresLeadership() {
    return !1;
  }
}
class an {
  constructor(e, r) {
    this.tokenManager = e, this.options = r, this.logger = g.createLogger(f.AUTO_RENEWAL), this.TOKEN_EVENT = "expiring", this.started = !1, this.renewTimerQueue = [], this.onTokenExpiring = this.onTokenExpiring.bind(this);
  }
  canStart() {
    return !!this.options.autoRenew && !this.started;
  }
  isStarted() {
    return this.started;
  }
  start() {
    return u(this, null, function* () {
      if (!this.canStart()) {
        this.logger.warn("Auto renewal cannot be started or is already running");
        return;
      }
      this.tokenManager.on(this.TOKEN_EVENT, this.onTokenExpiring), this.tokenManager.hasStarted() && this.processExpiredTokens(), this.started = !0;
    });
  }
  stop() {
    return u(this, null, function* () {
      if (!this.started) {
        this.logger.warn("Auto renewal already stopped");
        return;
      }
      this.tokenManager.off(this.TOKEN_EVENT, this.onTokenExpiring), this.renewTimerQueue = [], this.started = !1;
    });
  }
  requiresLeadership() {
    return !!this.options.syncStorage && I();
  }
  onTokenExpiring(e) {
    if (!this.options.autoRenew) {
      this.logger.debug("Skipping token renewal: auto renewal is disabled");
      return;
    }
    if (this.shouldThrottle()) {
      const r = new d("Too many token renewal requests");
      this.tokenManager.emitError(r);
    } else
      this.tokenManager.renew(e).catch(() => null);
  }
  shouldThrottle() {
    if (this.renewTimerQueue.push(Date.now()), this.renewTimerQueue.length <= 10) return !1;
    const e = this.renewTimerQueue.shift(), r = this.renewTimerQueue.at(-1);
    return Number(r) - Number(e) < 30 * 1e3;
  }
  processExpiredTokens() {
    const e = this.tokenManager.getTokens();
    e != null && e.accessToken && this.tokenManager.hasExpired(e.accessToken) && this.onTokenExpiring(e);
  }
}
class cn {
  constructor(e, r) {
    var n, s;
    this.logger = g.createLogger(f.SYNC_STORAGE), this.started = !1, this.enablePostMessage = !0, this.options = {
      syncStorage: (n = r.syncStorage) != null ? n : !0,
      syncChannelName: (s = r.syncChannelName) != null ? s : Ee.SYNC_STORAGE
    }, this.tokenManager = e, this.onTokenAdded = this.onTokenAdded.bind(this), this.onTokenRenewed = this.onTokenRenewed.bind(this), this.onTokenRemoved = this.onTokenRemoved.bind(this), this.onSetStorage = this.onSetStorage.bind(this), this.onMessage = this.onMessage.bind(this);
  }
  canStart() {
    return !this.started && !!this.options.syncStorage && I();
  }
  isStarted() {
    return this.started;
  }
  requiresLeadership() {
    return !1;
  }
  start() {
    return u(this, null, function* () {
      if (!this.canStart()) {
        this.logger.debug("Service cannot start. Aborting");
        return;
      }
      const { syncChannelName: e } = this.options;
      try {
        this.channel = new Q(e);
      } catch (r) {
        throw this.logger.debug(r), new d("Failed to create channel. SyncStorage is not supported in this browser");
      }
      this.tokenManager.on("added", this.onTokenAdded), this.tokenManager.on("renewed", this.onTokenRenewed), this.tokenManager.on("removed", this.onTokenRemoved), this.tokenManager.on("set-storage", this.onSetStorage), this.channel.addEventListener("message", this.onMessage), this.started = !0;
    });
  }
  stop() {
    return u(this, null, function* () {
      var e, r;
      if (!this.isStarted()) {
        this.logger.debug("Service already stopped. Aborting");
        return;
      }
      this.tokenManager.off("added", this.onTokenAdded), this.tokenManager.off("renewed", this.onTokenRenewed), this.tokenManager.off("removed", this.onTokenRemoved), this.tokenManager.off("set-storage", this.onSetStorage), (e = this.channel) == null || e.removeEventListener("message", this.onMessage), yield (r = this.channel) == null ? void 0 : r.close(), this.channel = void 0, this.started = !1;
    });
  }
  onTokenAdded(e) {
    var r;
    if (this.enablePostMessage)
      return (r = this.channel) == null ? void 0 : r.postMessage({
        type: "added",
        tokens: e
      });
  }
  onTokenRemoved(e) {
    var r;
    if (this.enablePostMessage)
      return (r = this.channel) == null ? void 0 : r.postMessage({
        type: "removed",
        tokens: e
      });
  }
  onTokenRenewed(e) {
    var r;
    if (this.enablePostMessage)
      return (r = this.channel) == null ? void 0 : r.postMessage({
        type: "renewed",
        tokens: e
      });
  }
  onSetStorage(e) {
    var r;
    if (this.enablePostMessage)
      return (r = this.channel) == null ? void 0 : r.postMessage({
        type: "set-storage",
        payload: e
      });
  }
  onMessage(e) {
    this.enablePostMessage = !1;
    const r = e.type;
    switch (r) {
      case "added":
        this.logger.debug("Received added message", e.tokens), this.tokenManager.emit("added", e.tokens);
        break;
      case "removed":
        this.logger.debug("Received removed message", e.tokens), this.tokenManager.emit("removed", e.tokens);
        break;
      case "renewed":
        this.logger.debug("Received renewed message", e.tokens), this.tokenManager.emit("renewed", e.tokens);
        break;
      case "set-storage":
        this.logger.debug("Received set-tokens message", e), this.tokenManager.setStorage(e.payload);
        break;
      default:
        W(r, new d(`Unknown sync message type ${r}`));
    }
    this.enablePostMessage = !0;
  }
}
const P = class P {
  constructor(e, r, n) {
    this.logger = g.createLogger(f.SINGLE_SIGN_OUT), this.checkSessionTimeout = 0, this.started = !1, this.tokenManager = e, this.router = r, this.options = n, this.checkSession = this.checkSession.bind(this), this.createCheckSessionTimeout = this.createCheckSessionTimeout.bind(this);
  }
  canStart() {
    return !this.started && !!this.options.singleSignout;
  }
  isStarted() {
    return this.started;
  }
  requiresLeadership() {
    return !!this.options.syncStorage && I();
  }
  /**
   * Starts the service. If the user currently has tokens in storage, this will create a 5 minute timeout
   * to revalidate the session is still active. If the session becomes inactive, the tokens will be cleared.
   */
  start() {
    return u(this, null, function* () {
      if (!this.canStart()) {
        this.logger.warn("Single sign out cannot be started or is already running");
        return;
      }
      this.logger.debug("Starting single sign out service"), yield this.checkSession(), this.tokenManager.on("added", this.createCheckSessionTimeout), this.started = !0;
    });
  }
  stop() {
    return u(this, null, function* () {
      this.tokenManager.off("added", this.createCheckSessionTimeout), clearTimeout(this.checkSessionTimeout), this.started = !1;
    });
  }
  createCheckSessionTimeout() {
    return u(this, null, function* () {
      clearTimeout(this.checkSessionTimeout);
      const e = Date.now() + P.CHECK_SESSION_TIMEOUT;
      this.logger.debug(
        "Creating new check session timeout. Check will run at ",
        new Date(e).toISOString()
      ), this.checkSessionTimeout = window.setTimeout(this.checkSession, P.CHECK_SESSION_TIMEOUT);
    });
  }
  checkSession() {
    return u(this, null, function* () {
      const e = this.tokenManager.accessToken;
      return !e || this.tokenManager.hasExpired(e) ? !1 : (yield this.router.checkSession({ accessToken: e.token })) ? (this.logger.debug("User session is still active"), yield this.createCheckSessionTimeout(), !0) : (this.logger.info("User session has expired, clearing tokens"), this.tokenManager.clear(), this.checkSessionTimeout = 0, !1);
    });
  }
};
P.CHECK_SESSION_TIMEOUT = 1e3 * 60 * 5;
let re = P;
class un {
  constructor(e, r) {
    this.logger = g.createLogger(f.AUTH_STATE_SERVICE), this.handler = () => (this.logger.debug("Token event received, updating auth state."), this.authStateManager.updateAuthState()), this.started = !1, this.tokenManager = e, this.authStateManager = r;
  }
  start() {
    return u(this, null, function* () {
      this.logger.debug("Starting AuthStateService"), yield this.authStateManager.updateAuthState(), this.tokenManager.on("added", this.handler), this.tokenManager.on("removed", this.handler), this.tokenManager.on("renew-error", this.handler), this.tokenManager.on("expired", this.handler), this.started = !0;
    });
  }
  stop() {
    return u(this, null, function* () {
      this.logger.debug("Stopping AuthStateService"), this.tokenManager.off("added", this.handler), this.tokenManager.off("removed", this.handler), this.tokenManager.off("renew-error", this.handler), this.tokenManager.off("expired", this.handler), yield this.authStateManager.updateAuthState(), this.started = !1;
    });
  }
  canStart() {
    return !this.started;
  }
  isStarted() {
    return this.started;
  }
  requiresLeadership() {
    return !1;
  }
}
const Ye = "autoRenew", Xe = "syncStorage", L = "leaderElection", Ze = "singleSignout", et = "authState", hn = [Ye, Xe, L, Ze, et], J = class J {
  constructor(e, r, n, s = {}) {
    this.logger = g.createLogger(f.SERVICE_MANAGER), this.started = !1, this.tokenManager = e, this.router = r, this.authStateManager = n, this.onLeader = this.onLeader.bind(this), this.options = S(S({}, J.defaultOptions), s), this.services = /* @__PURE__ */ new Map(), hn.forEach((i) => {
      const o = this.createService(i);
      this.services.set(i, o);
    });
  }
  get isReady() {
    return this.started;
  }
  /**
   * Called when the current instance becomes leader. Will start any services
   * that require leadership.
   */
  onLeader() {
    return u(this, null, function* () {
      this.started && (this.logger.debug("Appointed leader, starting services"), yield this.startServices());
    });
  }
  /**
   * Checks if any of the known services can start and require leadership.
   * Used to determine whether to begin leader election.
   */
  isLeaderRequired() {
    return Array.from(this.services.values()).some((e) => e.canStart() && e.requiresLeadership());
  }
  /**
   * Returns whether this instance of ServiceManager is the current leader.
   */
  isLeader() {
    var r;
    const e = this.services.get(L);
    return (r = e == null ? void 0 : e.isLeader()) != null ? r : !1;
  }
  /**
   * Returns whether the current channel has a leader.
   */
  hasLeader() {
    var r;
    const e = this.services.get(L);
    return (r = e == null ? void 0 : e.hasLeader()) != null ? r : !1;
  }
  /**
   * Starts all startable services
   */
  start() {
    return u(this, null, function* () {
      if (this.started) {
        this.logger.warn("Service manager already started");
        return;
      }
      yield this.startServices(), this.started = !0;
    });
  }
  /**
   * Stops all running services
   */
  stop() {
    return u(this, null, function* () {
      if (!this.started) {
        this.logger.debug("Service manager already stopped");
        return;
      }
      yield this.stopServices(), this.started = !1;
    });
  }
  /**
   * Return a service instance by name
   * @param name
   */
  getService(e) {
    return this.services.get(e);
  }
  startServices() {
    return u(this, null, function* () {
      const e = Array.from(this.services.entries()).filter(
        ([n, s]) => this.canStartService(n, s)
      ), r = yield Promise.allSettled(e.map(([n, s]) => s.start()));
      if (r.some((n) => n.status === "rejected")) {
        const n = r.filter((s) => s.status === "rejected").map((s) => s.reason);
        this.logger.error("One or more services failed to start:", n);
      }
    });
  }
  stopServices() {
    return u(this, null, function* () {
      for (const [e, r] of this.services.entries())
        r.isStarted() && (this.logger.debug(`Stopping service ${e}`), yield r.stop());
    });
  }
  /**
   * Check if a service can be started. Will account for current status, and
   * whether the service requires leadership.
   * @param name
   * @param service
   * @private
   */
  canStartService(e, r) {
    let n = r.canStart();
    return e === L ? n && (n = this.isLeaderRequired()) : r.requiresLeadership() && (this.logger.debug(`Service ${e} requires leadership. Current leader status: ${this.isLeader()}`), n && (n = this.isLeader())), this.logger.debug("Service", e, "can start:", n), n;
  }
  createService(e) {
    switch (e) {
      case L:
        return new on($(S({}, this.options), { onLeader: this.onLeader }));
      case Ye:
        return new an(this.tokenManager, this.options);
      case Xe:
        return new cn(this.tokenManager, this.options);
      case Ze:
        return new re(this.tokenManager, this.router, this.options);
      case et:
        return new un(this.tokenManager, this.authStateManager);
      default:
        return W(e, new d(`Unknown service ${e}`));
    }
  }
};
J.defaultOptions = {
  autoRenew: !0,
  syncStorage: !0,
  electionChannelName: Ee.LEADER_ELECTION,
  singleSignout: !0
};
let ne = J;
function dn() {
  return [window.location.protocol, "//", window.location.host, window.location.pathname].join("");
}
function ln() {
  return new URL(window.location.href).searchParams.has("code");
}
const ke = {
  locationWithoutQueryString: dn,
  hasAuthCode: ln
};
function tt(o) {
  return u(this, arguments, function* ({
    clientConfig: t,
    code: e,
    stateVerifier: r,
    router: n,
    pkce: s,
    tokenManager: i
  }) {
    var h;
    const a = yield n.token({
      client_id: t.clientId,
      redirect_uri: t.redirectUri,
      code_verifier: s.retrieveCodeVerifier(),
      grant_type: "authorization_code",
      code: e
    }), c = Oe(a, t.issuer);
    return yield r.verifyNonce((h = c.idToken) == null ? void 0 : h.claims.nonce), i.setTokens(c), s.removeCodeVerifier(), c;
  });
}
function gn(t) {
  const e = document.createElement("iframe");
  return e.src = t.toString(), e.style.display = "none", document.body.appendChild(e), () => {
    var r;
    document.body.contains(e) && ((r = e.parentElement) == null || r.removeChild(e));
  };
}
function fn({ issuer: t, timeout: e, state: r }) {
  let n, s;
  return new Promise((i, o) => {
    n = (a) => {
      if (a.data.state !== r) return;
      const c = new URL(t).origin;
      if (a.origin !== c)
        throw new d("Invalid origin");
      i(a.data);
    }, window.addEventListener("message", n), s = window.setTimeout(() => {
      o(new d("Authn flow timed out"));
    }, e);
  }).finally(() => {
    clearTimeout(s), window.removeEventListener("message", n);
  });
}
class pn {
  constructor(e) {
    this.router = e, this.logger = g.createLogger(f.AUTHN);
  }
  /**
   * @deprecated - Will not work without 3rd party cookies.
   */
  exists() {
    return u(this, null, function* () {
      return (yield this.get()).status === "Active";
    });
  }
  /**
   * @deprecated - Will not work without 3rd party cookies.
   */
  get() {
    return u(this, null, function* () {
      try {
        return yield this.router.me();
      } catch (e) {
        return { status: "Inactive" };
      }
    });
  }
  /**
   * @deprecated - Will not work without 3rd party cookies.
   */
  closeSession() {
    return u(this, null, function* () {
      try {
        yield this.router.deleteMe();
      } catch (e) {
        this.logger.error("Error closing session", e);
      }
    });
  }
}
class mn {
  constructor(e) {
    this.router = e.router, this.pkceManager = e.pkceManager, this.stateVerifier = e.stateVerifier, this.clientConfig = e.clientConfig, this.tokenManager = e.tokenManager, this.session = new pn(this.router), this.transactionManager = U.getSingleton(), this.logger = g.createLogger(f.AUTHN);
  }
  /**
   * @deprecated - Will not work without 3rd party cookies. Use PKCE Redirect Flow instead
   * @param scopes
   * @param state
   * @param sessionToken
   */
  getTokensWithoutPrompt(s) {
    return u(this, arguments, function* ({
      scopes: e,
      state: r,
      sessionToken: n
    }) {
      return this.logger.debug("Initializing authn flow"), yield this.transactionManager.create("login", () => u(this, null, function* () {
        var i;
        try {
          const { codeChallenge: o } = yield this.pkceManager.createCodePair(), a = this.stateVerifier.generate(r), c = yield this.router.login({
            prompt: "none",
            client_id: this.clientConfig.clientId,
            redirect_uri: this.clientConfig.redirectUri,
            scope: Ue((i = e == null ? void 0 : e.join(" ")) != null ? i : "openid"),
            state: a,
            code_challenge: o,
            code_challenge_method: this.pkceManager.CODE_METHOD,
            nonce: yield this.stateVerifier.createNonce(),
            response_type: "code",
            response_mode: "post_message",
            sessionToken: n
          }), h = fn({
            issuer: this.clientConfig.issuer,
            timeout: 12e5,
            state: a
          }), l = gn(c);
          try {
            const p = yield h;
            return yield tt({
              code: p.code,
              clientConfig: this.clientConfig,
              stateVerifier: this.stateVerifier,
              router: this.router,
              pkce: this.pkceManager,
              tokenManager: this.tokenManager
            });
          } finally {
            l();
          }
        } catch (o) {
          throw this.logger.error("Failed to acquire tokens", o), new d("Failed to acquire tokens", o);
        }
      }));
    });
  }
}
class wn {
  /**
   * Creates a new MapSSO instance.
   * @param clientId -See {@link SSOConfig#clientId
   * @param crypto - See {@link SSOConfig#crypto}
   * @param redirectUri - See {@link SSOConfig#redirectUri}
   * @param postLogoutRedirectUri - See {@link SSOConfig#postLogoutRedirectUri}
   * @param storage - See {@link SSOConfig#storage}
   * @param logLevel - See {@link SSOConfig#logLevel} or {@link LogLevel}
   * @param issuer - See {@link SSOConfig#issuer}
   * @param services - See {@link SSOConfig#clientId}
   * @param transformAuthState - See {@link SSOConfig.transformAuthState}
   * @param cookies - See {@link SSOConfig.cookies}
   */
  constructor({
    cookies: e,
    clientId: r,
    crypto: n = window.crypto,
    issuer: s,
    logLevel: i = E.WARN,
    postLogoutRedirectUri: o = window.origin,
    redirectUri: a,
    services: c,
    storage: h,
    transformAuthState: l
  }) {
    this.clientConfig = {
      issuer: s,
      postLogoutRedirectUri: o,
      clientId: r,
      redirectUri: a
    }, this.logger = g.initLogger(f.MAP_SSO, i), this.logger.debug("Initializing MapSSO"), this.storageManager = new te(h, e), this.crypto = n, this.oidcManager = new Ut({ issuer: s, cacheStorage: this.storageManager.getCacheStorage() }), this.stateVerifier = new St({
      crypto: n,
      transactionStorage: this.storageManager.getTransactionStorage()
    }), this.pkceManager = new wt({
      crypto: this.crypto,
      transactionStorage: this.storageManager.getTransactionStorage()
    }), this.v2Router = new xt({ issuer: s, oidcManager: this.oidcManager }), this.tokenManager = new mt({
      config: this.clientConfig,
      tokenStorage: this.storageManager.getTokenStorage(),
      router: this.v2Router
    }), this.authStateManager = new jt({ transformAuthState: l, sdk: this }), this.serviceManager = new ne(this.tokenManager, this.v2Router, this.authStateManager, c), this.transactionManager = U.getSingleton();
  }
  /**
   * Start the authorization service. This will initialize background services
   * to manage things like token events, auto-renew and session logout. See {@link ServiceManager} and {@link TokenManager}
   * for more details.
   *
   * Will trigger an auth state update.
   *
   * @returns {Promise<void>}
   */
  start() {
    return u(this, null, function* () {
      yield this.serviceManager.start(), yield this.tokenManager.start();
    });
  }
  /**
   * Stop the authorization service.
   * This will stop all background services in the {@link ServiceManager} as well
   * as the {@link TokenManager} events.
   * Emits an auth state update.
   *
   * @returns {Promise<void>}
   */
  stop() {
    return u(this, null, function* () {
      yield this.serviceManager.stop(), this.tokenManager.stop();
    });
  }
  /**
   * RP-Initiated Logout. This will redirect the client's browser to the authorization server where
   * the user will be logged out and the session destroyed.
   *
   * Marks all tokens in storage as pending removal to be cleaned up at next sdk initialization.
   *
   * @param postLogoutRedirectUri - The URI to redirect to after logout. Defaults to the current origin.
   * @param state - User defined state. Will be returned in the logout response.
   * @returns {Promise<void>} - Redirects the browser
   */
  signOut() {
    return u(this, arguments, function* ({
      postLogoutRedirectUri: e = window.origin,
      state: r = ""
    } = {}) {
      const n = this.tokenManager.idToken;
      if (!(n != null && n.token)) {
        this.logger.warn("User is not logged in. Missing idToken");
        return;
      }
      return yield this.transactionManager.create("logout", () => u(this, null, function* () {
        this.tokenManager.addPendingRemovalFlags(), this.tokenManager.stop();
        const s = yield this.v2Router.logout({
          post_logout_redirect_uri: e,
          state: this.stateVerifier.generate(r),
          id_token_hint: n.token,
          client_id: this.clientConfig.clientId
        });
        return window.location.assign(s);
      }));
    });
  }
  /**
   * Uses the current auth state to determine if the user is authenticated.
   * If the `onExpiredToken` option is set to 'renew' or autoRenew is enabled, will attempt to renew the tokens if expired.
   * If the `onExpiredToken` option is set to 'remove', will clear the tokens from storage.
   * @param onExpiredToken
   * @returns {boolean}
   */
  isAuthenticated() {
    return u(this, arguments, function* ({ onExpiredToken: e } = {}) {
      const r = !!(e === "renew" || this.serviceManager.options.autoRenew), n = e === "remove", s = yield this.authStateManager.updateAuthState();
      if (!(s != null && s.isAuthenticated)) {
        if (n)
          return this.tokenManager.clear(), !1;
        if (s && r)
          try {
            return !!(yield this.tokenManager.renew());
          } catch (i) {
            return this.tokenManager.clear(), !1;
          }
      }
      return !!(s != null && s.isAuthenticated);
    });
  }
  /**
   * Creates a new OIDC authorization request and redirects the user to the authorization server to authenticate.
   * The user will be returned to the `redirect_uri` specified in the client config.
   *
   * @param state - The state parameter to use for the authorization request. This is used to prevent CSRF attacks.
   *                The auth sdk will always generate a cryptographically safe random state parameter.
   *                Use this option if you need to pass additional custom state for your authentication flow.
   *                Any state you provide will be returned from the `handleRedirect` method, or provided as a query parameter to the `originalUri` if set.
   * @param scope - The scopes that are requested for this access token. By default, the auth sdk will include the `openid` scope.
   *                Please specify any additional scopes your application requires.
   *                See: https://datatracker.ietf.org/doc/html/rfc6749#section-3.3 for more information.
   *
   * @param ui_locales (optional) - The list of locale preference in order of priority. e.g. ['en', 'ja'].
   *                                If not provided, the login screen will determine the locale based on the user's browser settings.
   *
   * @returns {Promise<void>} - Redirects the browser
   *
   * @throws {AuthSdkError} - if it fails to initialize the redirect flow.
   */
  signInWithRedirect() {
    return u(this, arguments, function* ({
      state: e = "",
      scope: r = "openid",
      ui_locales: n
    } = {}) {
      return yield this.transactionManager.create("login", () => u(this, null, function* () {
        try {
          this.logger.debug("Initializing redirect flow");
          const { clientId: s, redirectUri: i } = this.clientConfig, { codeChallenge: o } = yield this.pkceManager.createCodePair(), a = yield this.v2Router.login({
            prompt: "display",
            client_id: s,
            redirect_uri: i,
            scope: Ue(r != null ? r : "openid"),
            state: this.stateVerifier.generate(e),
            code_challenge: o,
            code_challenge_method: yield this.oidcManager.codeChallengeMethod(this.pkceManager.CODE_METHOD),
            nonce: yield this.stateVerifier.createNonce(),
            response_type: yield this.oidcManager.responseType("code"),
            response_mode: yield this.oidcManager.responseMode("query"),
            ui_locales: n == null ? void 0 : n.map((c) => {
              var h;
              return (h = c == null ? void 0 : c.trim()) != null ? h : "";
            }).join(" ")
          });
          return window.location.assign(a);
        } catch (s) {
          throw this.logger.error("Failed to initialize redirect flow", s), new d("Failed to initialize redirect flow", s);
        }
      }));
    });
  }
  /**
   * Returns true if the current route is a valid login redirect uri.
   * Checks the current location against the registered redirect uri and verifies there is an auth code parameter.
   *
   * @returns {boolean}
   */
  isLoginRedirect() {
    const e = ke.locationWithoutQueryString() === this.clientConfig.redirectUri && ke.hasAuthCode();
    return this.logger.debug(`Checking for redirect route: ${e}`), e;
  }
  /**
   * Should be called by the redirect_uri page. Will handle extracting an authorization code from the url,
   * and exchanging it for an access token.
   *
   * Accepts an optional `redirectParams` object, which can be used to pass in the `code` and `state` parameters
   * manually. If no `redirectParams` are given, it will read them from the current url.
   *
   * This function is not idempotent. Auth codes can only be exchanged once. Be sure to only invoke this method
   * once per auth code, or subsequent calls will fail.
   *
   * If an `originalUri` had been set via {@link setOriginalUri}, the user will be redirected to that uri after a successful login.
   * If no `originalUri` was present, the function will return the tokens and state from the authorization response.
   *
   * @param redirectParams
   *
   * @returns {Promise<{ tokens: SSOTokens; state: string }>} - Returns the tokens and state from the authorization response.
   * @throws {AuthSdkError} - If multiple calls are made to this method before token exchange has been completed or token exchange fails.
   */
  handleRedirect(e) {
    return u(this, null, function* () {
      return this.transactionManager.create("handle-redirect", () => u(this, null, function* () {
        try {
          e || (e = this.v2Router.parseRedirectUrl());
          const r = this.stateVerifier.verify(e.state), n = yield tt({
            clientConfig: this.clientConfig,
            code: e.code,
            stateVerifier: this.stateVerifier,
            router: this.v2Router,
            pkce: this.pkceManager,
            tokenManager: this.tokenManager
          }), s = this.stateVerifier.decode(r), i = this.getOriginalUri();
          return i && (new URL(i).searchParams.append("state", s), this.removeOriginalUri(), window.location.replace(i)), { tokens: n, state: s };
        } catch (r) {
          throw this.logger.error("Failed to exchange auth code for tokens", r), new d("Failed to exchange auth code for tokens", r);
        }
      }));
    });
  }
  /**
   * Used to set the original uri that the user was trying to access before being redirected to the authorization server.
   * If provided, the user will be redirected to this uri after a successful login and token exchange.
   *
   * Example Flow:
   * 1. User navigates to /protected-route
   * 2. sdk.setOriginalUri('/protected-route')
   * 3. sdk.signInWithRedirect({ state: 'user-provided-state' })
   * 4. User is redirected to the authorization server to authenticate
   * 6. User is redirected back to the registered redirect_uri
   * 7. sdk.handleRedirect()
   * 8. sdk exchanges auth code for tokens
   * 9. sdk redirects the user to the original uri: /protected-route?state=user-provided-state
   *
   * @param uri
   *
   * @returns {void}
   */
  setOriginalUri(e) {
    const r = this.storageManager.getTransactionStorage(), n = e instanceof URL ? e.toString() : e;
    r.setItem(w.ORIGINAL_URI, n);
  }
  /**
   * Returns the current `originalUri` if set.
   *
   * return {string | null}
   */
  getOriginalUri() {
    return this.storageManager.getTransactionStorage().getItem(w.ORIGINAL_URI);
  }
  /**
   * Removes the `originalUri` from storage.
   *
   * @returns {void}
   */
  removeOriginalUri() {
    this.storageManager.getTransactionStorage().removeItem(w.ORIGINAL_URI);
  }
  /**
   * Set custom headers to be sent with all requests to the authorization server.
   * Note that this cannot be used to overwrite headers set by the auth sdk.
   * Be aware that disallowed headers may be blocked by CORS, resulting in a failed request.
   * @param headers
   *
   * @returns {void}
   */
  setHeaders(e) {
    this.v2Router.setHeaders(e);
  }
  /**
   * Retrieve details about the current user from the authorization server.
   * Requires an access token to be present in storage.
   *
   * @returns {Promise<V2UserInfoResponse>}
   *
   * @throws {AuthSdkError} - if no tokens are present or the token has expired
   * @throws {NetworkError} - if the network request fails
   */
  getUserInfo(e) {
    const r = e != null ? e : this.tokenManager.accessToken;
    if (!r || this.tokenManager.hasExpired(r))
      throw new d("Invalid or expired access token");
    return this.v2Router.userInfo({ accessToken: r.token });
  }
  /**
   * Parse oauth raw state param from the url. Can be used to extract the oauth state from urls after login/logout
   * redirect. If no state string is provided, it will attempt to parse the `state` query param from the current url.
   *
   * Note: This method does NOT verify the state string. The state is verified by the `handleRedirect` method.
   * @param state - The encoded state string to parse
   * @throws AuthSdkError - if no state string is provided and no state param is found in the current url
   */
  parseOAuthState(e) {
    const r = e != null ? e : new URLSearchParams(window.location.search).get("state");
    if (!r)
      throw new d("Missing state parameter");
    return this.stateVerifier.decode(r);
  }
  /**
   * Checks if the user's session is currently active. Returns a boolean.
   * Requires a valid access token. If no access token is provided or
   * present in token storage, it will return false.
   */
  checkSession(e) {
    return u(this, null, function* () {
      var n;
      const r = e != null ? e : (n = this.tokenManager.accessToken) == null ? void 0 : n.token;
      return r ? this.v2Router.checkSession({ accessToken: r }) : !1;
    });
  }
  /**
   * Returns the raw access token string from storage
   * The decoded access token can be retrieved from the {@link TokenManager}
   */
  getAccessToken() {
    var e, r;
    return (r = (e = this.tokenManager.accessToken) == null ? void 0 : e.token) != null ? r : null;
  }
  /**
   * Returns the raw id token string from storage
   * The decoded id token can be retrieved from the {@link TokenManager}
   */
  getIdToken() {
    var e, r;
    return (r = (e = this.tokenManager.idToken) == null ? void 0 : e.token) != null ? r : null;
  }
  /**
   * Returns the raw refresh token string from storage
   */
  getRefreshToken() {
    var e, r;
    return (r = (e = this.tokenManager.refreshToken) == null ? void 0 : e.token) != null ? r : null;
  }
  /**
   * @deprecated - Will not work without 3rd party cookies. Use PKCE Redirect Flow instead
   */
  get authn() {
    return new mn({
      router: this.v2Router,
      pkceManager: this.pkceManager,
      stateVerifier: this.stateVerifier,
      clientConfig: this.clientConfig,
      tokenManager: this.tokenManager
    });
  }
}
export {
  d as AuthSdkError,
  j as AuthorizationError,
  E as LogLevel,
  wn as MapSSO,
  Ie as NetworkError
};
//# sourceMappingURL=auth-sdk.js.map
